//外部组件引入
import React, {
	Component
} from 'react';
import { Flex, Button, Modal, Result, List, Badge ,Toast,InputItem,ActionSheet} from 'antd-mobile';
import { inject, observer } from 'mobx-react';
//自定义内容引入
import UserList from "./userList";
import Config from "../../config";
import WxApi from "../../common/wxapi";
import { getRandomLotteryBanner } from "../../common/lotteryBanner";
import { withAppBasename } from "../../common/router";
import { updateAllSeo } from '../../common/seo';
import NewMsgDialog from '../../components/NewMsgDialog';
import SetUserInfo from '../../components/SetUserInfo';
import ManageDialog from '../../components/ManageDialog';
import DeleteEnrollDialog from '../../components/DeleteEnrollDialog';
import VocherModal from '../../components/VocherModal';
//图片引入
import img_identification_p from "../../res/img/ic_identification_person_small.png";//个人
import img_identification_c from "../../res/img/ic_identification_company_small.png";//企业
import img_identification_g from "../../res/img/ic_identification_gzh_small.png";//公众号
import wxapi from "../../common/wxapi";

import img_qun from "../../res/img/ic_detail_group_photo.png"
import img_subscription from "../../res/img/ic_detail_notice_guide.png"
import img_mask_arrow from "../../res/img/ic_mask_arrow.png";
import right_arrow from "../../res/img/right_arrow.png";
import left_arrow from "../../res/img/icon_left_arrow.png";
import close_btn from "../../res/img/ic_popup_close.png";
import ic_person_identity from "../../res/img/ic_person_identity_V.png";
import is_follow from "../../res/img/ic_detail_follow_done.png";
import no_follow from "../../res/img/ic_detail_follow.png";
import ic_top_row from "../../res/img/ic_detail_top_arrow.png"
import ic_top_notice from "../../res/img/ic_detail_top_notice.png"
import ic_conct_btn from "../../res/img/ic_conct_btn.png"

import icon_right_img from '../../res/img/right_arrow_blue.png'
import icon_create_enroll from '../../res/img/icon_create_enroll.png'
import icon_adress from '../../res/img/icon_adress.png'
import icon_video_img from '../../res/img/big-num-video.png'
const Item = List.Item;
const Brief = Item.Brief;

@inject("enrollStore", "loadingStore", "myEnrollStore", "authStore")
@observer
class App extends Component {
	state = {
		height: 0,
		lotteryBanner: getRandomLotteryBanner(),
		sharePanel:'none',//分享选择界面
		showDetailQrCode:'none',
		showHomePageQrCode:'none',
		shareFriend:'none',
		tokenPanel:'none',//口令输入框
		token:'',
		sub_user: 0,
		btnTypeText:["立即报名", "点击填写", "立即预约", "了解更多", "下一步","立即购买",'立即申请','立即报名'],
		isWeixin:true,//判断是否在微信环境
		isMobile:true,//判断是否是移动环境
		showSeat:false,
		showReverse:false,
		showReadDialog:false,//提交前阅读弹窗
		countDown:5,
		hasActive:true,//这个活动是否存在
		currIndex:0,
		reverseList:[],
		tagList:[],
		showLink:false,//短链
		showWxlink:false,
		currAudioIndex:-1,	 	
		censorModal: false,
		enroll_token: '',
		showEnrollToken: false,
		groupList: [],
		show_notice: false,
		vipList: [],
		isVertical: false,
		showManage: false,
		showVoucher: false,
		deleteDialogShow: false,
		auto_enroll: '',
		timeInfo: {
			hour: 0,
			minute: 0,
			second: 0,
		}
	};

	getDetail() {
		if(Config.EID) {		 
			let _this = this;			 
			this.props.enrollStore.getEnrollDetailByEid().then(async(res) => {
				Toast.loading('正在加载数据');
				let {detail} = _this.props.enrollStore;
				let isAwait = sessionStorage.getItem('isAwait');      				 
				if(res.data.data && res.data.data.is_await == 1 && isAwait !=1){
					sessionStorage.setItem('isAwait',1);
					setTimeout(()=>{                     
						_this.getDetail();
					},3000)
					return;
				}   
				Toast.hide();
				// share=2 的小程序卡片仅限发起人和管理员，H5 转发入口统一展示无权限页。
				const isOwnerOrAdmin = Number(detail.is_owner) === 1 || Number(detail.is_admin) === 1 || Number(detail.admin1) === 1 || Number(detail.admin3) === 1 || (detail.admins_node && detail.admins_node.length > 0);
				if(Number(detail.share) === 2 && !isOwnerOrAdmin){
					_this.props.history.replace('/error/6');
					return;
				}
				detail.owner_pic = await wxapi.checkImage(detail.owner_pic);
				let themColor = '#00a8f3';
				if(detail && detail.btn_config && detail.btn_config.color){
					themColor = detail.btn_config.color;
				}
				let vipList = [];
				if(detail.user_owner_vip_all && detail.user_owner_vip_all.length){
					vipList = detail.user_owner_vip_all.filter(vip => vip.expire > new Date().getTime() / 1000).map(vip => vip.card_id); //获取当前用户有哪些没过期的会员卡	 
				}				
				_this.setState({
					sub_user: detail.sub_user,
					detail: detail,
					hasActive:res.data.sta == -1?false:true,  //-500token失效 -1活动不存在
					themColor,
					vipList: vipList,
					auto_enroll: detail.auto_enroll
				})
				if(res.data.data && res.data.data.is_await != 1){//// 超时情况延迟请求接口
					this.getAdultCode() //右侧广告码
				}; 
				 
				//订阅消息回调
				let sceneId = WxApi.getQueryString("scene");
				let openid = WxApi.getQueryString("openid");
				let notice = sessionStorage.getItem("notice");
				if(sceneId && openid && notice =='notice'){
					_this.receiveNotice(sceneId,openid)
				}

				if(detail.btn_config && (detail.btn_config.btn_cd == 1 || detail.btn_config.btn_cd == 2)){ //开启了倒计时
					this.getTimeDown(detail);
				}
		 
				if(detail.sub_user_setting && detail.sub_user_setting.indexOf('group_enter') != -1){ //指定群聊可参与				 		
					let info_id = WxApi.getQueryString('info_id')
					let verified = WxApi.getQueryString('verified')			 		
					if(detail.is_owner || detail.admin3 == 1 || (info_id && verified)){
						this.initShareGroup(detail);
					}else if(!detail.info_id){
						this.props.history.push('/error/5')
					}	 					
				}

				if(detail.title){
					document.title = detail.title
					updateAllSeo(detail)
					sessionStorage.setItem("authorizer_appid",detail.authorizer_appid);
					if(detail && detail.temp == 6){
						_this.props.history.push('/group?eid='+ Config.EID+'&referer='+Config.referer)
						return;
					}
					
					if(!Config.TOKEN){
						let isWeixin = WxApi.isWeixn();
						let isMobile = WxApi.isMobile();
						let isUnionPay = wxapi.isUnionPay();
						const code = WxApi.getQueryString("code");
						const isOldUser = localStorage.getItem('isOldUser'); //微信曾经授权过报名工具的用户
						if(!isWeixin){
							_this.getsShareImg(1);
							_this.setState({
								isWeixin:isWeixin,
								isMobile:isMobile,
								isUnionPay,
							})
						}else if(code || isOldUser){//微信收授权后，则重新登录
							WxApi.jumpWxAuth(() => {
								_this.getDetail();
							}, { auto: true });
						}
					}else if(res.data.data && res.data.data.is_await != 1){
						_this.getNoticeInfo(detail);  //顶部展示通知
					}
					sessionStorage.setItem("isWixin",this.state.isWeixin);
				}
				
				if(detail.unionid){
					sessionStorage.setItem('unionid',detail.unionid);
					sessionStorage.setItem('owner_unionid',detail.owner_unionid);
				}
				
				let _url = wxapi.replaceParamVal('referer',Config.referer);
				let shareText = "";
				if(detail.auth > 1){
					shareText = detail.sign_name;
				}else if(detail.auth == 1){
					shareText = "<点击查看内容>"
				}else{
					shareText = "来自报名工具小程序"
				}
				if(detail.content && Array.isArray(detail.content)){
					let index = detail.content.findIndex(item=>item.type === 'text'&&item.value)
					if(index>-1){
						shareText = detail.content[index].value
					}
				}
				
				if(res.data.data && res.data.data.is_await != 1){// 拥堵情况延迟请求接口
					if(detail && (detail.count <= Number(detail.user_list_limit) || (detail.admins_node && detail.admins_node.length > 0)|| detail.is_owner)){//根据后台接口的阈值来限制加载
						this.props.enrollStore.restUserListPage();
					}else{
						this.props.enrollStore.initUserList() //初始化已提交列表
					}
				};

				if(detail.temp == 10 || detail.temp == 8){ //选座&预约
					this.wxJumpPath = `/pages/detail/reserve.html?eid=${detail.eid}&referer=${Config.referer}`;
				}else{
					this.wxJumpPath = `/pages/detail/detail.html?eid=${detail.eid}&referer=${Config.referer}`;				 
				}

				if(detail.temp == 5 && !detail.info_id){
					let no_quoto = false;
					this.props.enrollStore.getItemData().then(res=>{
						if(res.data.sta == 0){
							let enrollData = res.data.data.items;
							no_quoto = enrollData.every(item=>item.remain == 0);							 
						}
						detail.no_quoto = no_quoto;					 				 
					})
				}
				 
				await this.toEditorMsg(detail)// 如果是发起人编辑参与者报名信息，则直接跳转
				this.toMoveEnroll()//如果是名额转让，则直接跳转报名页面				 
				wxapi.setShare(detail.title, shareText, _url, detail.banner || Config.LOGO);
				/*
				 * Non-VIP initiators are allowed to access the detail page.
				if(detail.auth == 0){					
					if(wxapi.isWeixn()){ //这个是为了避免在ios中注册微信api与初始进入页面不一致，导致微信api不生效
						const checkWxApi = () => {
							return new Promise((resolve, reject) => {
							  let interval = setInterval(() => {
								if (typeof window.wx !== 'undefined' && window.wx && window.wx.openBusinessView) {
									clearInterval(interval);
									resolve();
								}
							  }, 200);
							});
						  }						  
						checkWxApi().then(() => {
							this.props.history.replace('/share?eid='+detail.eid+'&referer='+Config.referer);
						});
					}else{
						this.props.history.replace('/share?eid='+detail.eid+'&referer='+Config.referer);	
					}													
				}
				*/
				if(detail.censor_status == 2) { //内容违规
					this.props.history.push('/error/2')
				}else if(detail.censor_status == 3){ //活动有争议
					this.setState({ censorModal: true })					 
				}
			 
				if(localStorage.getItem('cert_eid') == detail.eid){
					localStorage.removeItem('cert_eid');
					this.setState({showVoucher: true});
				}
				if(detail.banner){
					//根据短边来裁剪banner图片
					let _img  = new Image();
					_img.src = detail.banner;
					_img.onload = function(detail){						 
						if(_img.height >= _img.width * 1.5){
							_this.setState({isVertical: true});
						}				 
					}
					_img.onerror = function(err){
						detail.banner = null;
					}
				}else{
					detail.banner = '';
				}
				let isBackBtn = sessionStorage.getItem('isBackBtn');
				if(detail.status != 2 && detail.auto_enroll == 1 && !Config.isFromBack && !isBackBtn){ //活动设置了自动跳转 且不是返回键
					setTimeout(()=>{
						this.toAutoEnroll(detail);			 
					}, 1000)																							
					// setTimeout(()=>{
					// 	let btn = document.querySelector('.enroll-btn')						 
					// 	if(btn){
					// 		btn.click();
					// 	}
					// }, 500)					
				}else if(isBackBtn == 1){
					sessionStorage.removeItem('isBackBtn');
				}				
			}, () => {
				this.props.history.push('/page-404') //未知的组织报名
			});
		} else {
			this.props.history.push('/page-404')
		}
	}
	// 如果是发起人编辑参与者报名信息，则直接跳转
	toEditorMsg(detail){
		if(!detail || !detail.title)return
		return new Promise(async (resolve, reject)=>{
			sessionStorage.removeItem('fromPC')		
			let info_id = WxApi.getQueryString('info_id')
			let verified = WxApi.getQueryString('verified')
			let token = WxApi.getQueryString("tk")

			if(info_id && verified){		
				if(token && !WxApi.isWeixn()){
					localStorage.setItem(Config.wx_token_key,token)			
				}	
				sessionStorage.setItem('fromPC',1)//从pc过来编辑报名信息
				this.props.myEnrollStore.setCurrentEnroll({info_id,verified})
				this.props.enrollStore.getItemData().then(()=>{
					const d = this.props.enrollStore.detail || detail;
					if (verified == 4) {
						// 待支付 → 锁单页
						this.props.history.push({
							pathname: '/enrollLock',
							search: 'info_id=' + info_id + '&eid=' + (Config.EID || d.eid || '') + '&temp=' + (d.temp || 0) + '&verify=' + (d.verify || 0) + '&auth=' + (d.auth || 0)
						});
					} else {
						this.props.history.push('/enrollForm');
					}
					reject();
				})			
			}else if(WxApi.getQueryString('eid') && WxApi.getQueryString('id')){ //打印pdf上的二维码扫描进入这里									 
				if(!Config.TOKEN){
					React.$wx.webLogin();
					return;
				}
				let hasJumpedEnrollForm = sessionStorage.getItem('hasJumpedEnrollForm') //避免进入用户报名信息之后点击返回，页面进入死循环无法返回				 
				if(Config.TOKEN && hasJumpedEnrollForm != 1){
					info_id = WxApi.getQueryString('id')
					await this.props.myEnrollStore.getEnrollById(info_id)
					let {enrollEntry} = this.props.myEnrollStore;				 
					if(detail.is_owner || enrollEntry.info_unionid == detail.unionid){
						this.props.myEnrollStore.setCurrentEnroll({info_id})
						this.props.enrollStore.getItemData().then(()=>{
							sessionStorage.setItem('hasJumpedEnrollForm', '1')				 
							this.props.history.push('/enrollForm')
							reject()
						})	
					}else{
						resolve()
					}						
				}else{
					resolve()
				}						
			}else if(WxApi.getQueryString("path_type") == 'transfer'){
				this.props.history.push('/transfor')
			}else{
				resolve()
			}		
		})		
	}
	//如果是名额转让，则直接跳转报名页面
	toMoveEnroll(){
		sessionStorage.removeItem('fromMove')		
		let move_id = WxApi.getQueryString('move_id')					
		if(move_id){
			if(!Config.TOKEN){
				React.$wx.webLogin()
				return
			}
			sessionStorage.setItem('fromMove',1)//从转让名额过来编辑报名信息
			this.props.myEnrollStore.setCurrentEnroll({info_id:move_id})
			this.props.enrollStore.getItemData().then(()=>{
				this.props.history.push('/enrollForm')
			})	
		}
	}	
	setReverseTag(detail){
		if(detail.temp == 8){
			let tagList = ['全部'],items = detail.items||[]
			for(let a = 0;a < items.length;a++){
				if(items[a].tag && tagList.indexOf(items[a].tag) == -1){
					tagList.push(items[a].tag)
				}
			}
			this.setState({
				reverseList:detail.items,
				tagList,
				tagList:tagList.length>1?tagList:[]
			})
		}
	}
	initShareGroup(detail){
		this.props.myEnrollStore.getShareGroup(detail.eid).then(res=>{
			if(res.sta == 0){				 
				this.setState({groupList: res.data.open_group});
			}
		})		
	}
	// 从普通浏览器跳转到微信小程序
	getTicket(detail){
		this.props.myEnrollStore.getShortTicket({eid:detail.eid, referer: Config.referer}).then(res=>{
			if(res.sta == 0){
				window.location.href = res.data.scheme_ticket;					
			}
		})
	}
	// 倒计时
	getTimeDown(detail){
		if(this.timeDown)clearInterval(this.timeDown);
		let endTime = detail.end_time * 1000;
		if(detail.btn_config.btn_cd == 2){
			endTime = detail.start_time * 1000;
		}		
		let nowTime = new Date().getTime();
		let time = endTime - nowTime;	
		if(time > 0){
			let hour = Math.floor(time / 1000 / 60 / 60);
			let minute = Math.floor(time / 1000 / 60 % 60);
			let second = Math.floor(time / 1000 % 60);
			this.setState({
				timeInfo: {
					hour,
					minute,
					second
				}
			})
			this.timeDown = setInterval(() => {				
				if(second > 0){
					second--;
				}else{
					second = 59;
					if(minute > 0){
						minute--;
					}else{
						minute = 59;
						if(hour > 0){
							hour--;
						}else{
							clearInterval(this.timeDown);
							detail.status = detail.btn_config.btn_cd == 2 ? 1 : 2;					 							 
							this.setState({hour: 0, minute: 0, second: 0, isHideBtn: true, detail});		
							return;					 
						}
					}
				}
				this.setState({
					timeInfo: {
						hour,
						minute,
						second
					}
				})
			}, 1000)
		}else{
			this.setState({isHideBtn: true});
		}
	}
	//订阅通知
	receiveNotice(sceneId,openid){
		this.props.myEnrollStore.subNotice(sceneId,openid).then(() => {
			let {orderStatus} = this.props.myEnrollStore;
			if(orderStatus){
				sessionStorage.removeItem("notice");
				Toast.success('订阅成功!', 1);
			}
		});
	}
	
	//获取微信系统通知信息
	getNoticeInfo(detail){
		let _this = this;
		if(Config.TOKEN){
			this.props.myEnrollStore.getNoticeAll(detail.eid).then((res) => {
				_this.renderNotice(detail)
				//对齐小程序 detailnotice follow 分支：权限项为 info_id/on_behalf/is_owner/is_admin/sup_vip，发起人/管理员未报名也可见
				let followPerm = this.canShowSubmitNotice(detail) || detail.on_behalf == 1;
				let showScene = (detail.follow.scene == 0 && followPerm) || (detail.follow.scene == 1 && detail.verify == 1 && detail.verified == 1) || (detail.follow.scene == 2 && followPerm || (detail.verify ==1 && detail.verified == -1));
				const {wxNotice} = this.props.myEnrollStore;
				let noticeArr = wxNotice.msg_list;
				let sms_list = wxNotice.sms_list;
				if(noticeArr && noticeArr.length > 0){
					noticeArr = noticeArr.filter(item => !item.time_out || item.time_out == 0);
				}
				let show_notice = false;
				if(noticeArr && noticeArr.length > 0 &&  noticeArr[0].content && this.canShowSubmitNotice(detail)){
					show_notice = true;
				}else if(sms_list && sms_list.length > 0){
					show_notice = true;
				}else if(detail && detail.follow && detail.follow.type > 0 && (detail.follow.desc||detail.follow.qrcode||detail.follow.link_url) && showScene){
					show_notice = true;
				}
				this.setState({show_notice});
			});
		}
	}

	getAdultCode(){ //右侧广告码		 
		this.props.enrollStore.getShare(1).then((d) => {
			if(d && d.url) {
				this.setState({
					shareImgUrl: d.url,
				})
				this.props.myEnrollStore.setShareImg(d.url);
			}
		})		 
	}	 
	async toAutoEnroll(detail){
        let isEditor = detail.period_config && detail.period_config.day_type == 'all' && detail.period_config.count == 1; //如果是总共一次，则显示编辑按钮
        if(detail.status == 2 && !detail.info_id && detail.on_behalf == 0){
            return;
        }else if(detail.status == 0){
            return;
        }else if(detail.temp == 8 && !detail.info_id){
            return;
        }else if((detail.count >= detail.limit && !detail.info_id && detail.on_behalf==0 && detail.limit!=0 && detail.queue && (detail.temp != 5 || !(detail.items && detail.items.length > 0))) || (detail.temp == 5 && detail.items && detail.items.length > 0 && detail.no_quoto && detail.queue && !detail.info_id && detail.on_behalf == 0)){
            return;
        }else if((detail.status == 1 && ((!detail.info_id && !detail.period) || (detail.period == 1 && !detail.period_info) ) && detail.on_behalf == 0) || (detail.on_behalf && (detail.pay_status == 1 || detail.pay_status == 2))){
            if(detail.sub_user_setting && detail.sub_user_setting.length && detail.sub_user_setting.indexOf('all') == -1 && detail.sub_user_setting.indexOf('white') == -1){                         
				if((detail.sub_user_setting.indexOf('vip') != -1 && this.state.vipList.length > 0) || (detail.sub_user_setting.indexOf('fans') != -1 && detail.sub_user)){
					await this.getEnrollStatus(detail)                  
					this.props.enrollStore.getItemData().then(()=>{
						this.gotoEnroll(detail)
					})
					return
				}else if(detail.sub_user_setting.indexOf('fans') != -1 && !detail.sub_user){
					Modal.alert('温馨提示','你还不是当前组织的粉丝，不能参加此活动，请先去关注活动组织者', [
						{ text: '取消', style: 'default'},
						{ text: '去关注', onPress: () => { 
							React.$wx.jumpNewPath.call(this,'/h/'+sessionStorage.getItem('owner_unionid'))
						} },
					])
					return
				}else if(detail.sub_user_setting.indexOf('vip') != -1 && !this.state.vipList.length){
					Modal.alert('需先获取会员卡','本活动仅限持有会员卡的用户提交，请点击获取会员卡了解详细内容', [
						{ text: '取消', style: 'default'},
						{ text: '获取会员卡', onPress: () => { 
							let cid = detail.items_fee && detail.items_fee.vip_card_id ? detail.items_fee.vip_card_id : ''
							React.$wx.jumpNewPath.call(this,'/apply-vip?cid='+cid)
						} },
					])
					return
				}else if(detail.sub_user_setting.indexOf('end_all') != -1){
					Modal.alert('温馨提示','发起人设置了所有人不可提交，暂时无法提交', [
						{ text: '取消', style: 'default'},
						{ text: '去留言', onPress: () => { 
							React.$wx.jumpNewPath.call(this,'/message')
						} },
					])
					return
				}                        
			}
			if(detail.period_config && detail.period_config.day_type == 'day' && (detail.period_config.daily_start > 0 || detail.period_config.daily_end > 0)){
				let {daily_start, daily_end} = detail.period_config;
				let Today = new Date(new Date(new Date().getTime()).setHours(0,0,0,0)).getTime();
				if(new Date().getTime() < Today+daily_start*1000 || new Date().getTime() > Today+daily_end*1000){
					this.props.myEnrollStore.setCurrentEnroll({info_id: detail.info_id});
					this.props.history.push('/cert?day_type=day');
					return;
				}                                                           
			}
			await this.getEnrollStatus(detail)
			await this.userNickname.checkUserName(); //判断是否有昵称                  
			this.props.enrollStore.getItemData().then(()=>{
				this.gotoEnroll(detail)
			})      
        }else if(detail.status == 2 && detail.info_id && detail.on_behalf == 0){
            this.props.enrollStore.getItemData().then(()=>{
                this.props.myEnrollStore.setCurrentEnroll({info_id: detail.info_id});
                if (detail.verified == 4) {
                    // 待支付 → 锁单页
                    this.props.history.push({
                        pathname: '/enrollLock',
                        search: 'info_id=' + detail.info_id + '&eid=' + (Config.EID || detail.eid || '') + '&temp=' + (detail.temp || 0) + '&verify=' + (detail.verify || 0) + '&auth=' + (detail.auth || 0)
                    });
                } else {
                    this.props.history.push('/enrollForm');
                }
            })   
        }else if(detail.status == 2 && (detail.info_id || detail.on_behalf)){
            this.props.enrollStore.getItemData().then(()=>{
                this.props.history.push('/enrollList')
            })
        }else if(detail.temp != 8 && detail.status == 1 && (detail.info_id || (detail.period == 1 && detail.period_info)) && (isEditor || (detail.on_behalf_limit == 0 && detail.period_config && !detail.period_config.count))){
            this.props.enrollStore.getItemData().then(()=>{
                this.props.myEnrollStore.setCurrentEnroll({info_id: detail.info_id});
                if (detail.verified == 4) {
                    // 待支付 → 锁单页
                    this.props.history.push({
                        pathname: '/enrollLock',
                        search: 'info_id=' + detail.info_id + '&eid=' + (Config.EID || detail.eid || '') + '&temp=' + (detail.temp || 0) + '&verify=' + (detail.verify || 0) + '&auth=' + (detail.auth || 0)
                    });
                } else {
                    this.props.history.push('/enrollForm');
                }
            })  
        }else if(detail.status == 1 && ((detail.info_id || (detail.period == 1 && detail.period_info)) || (detail.period_config &&  detail.period_config.count > 1) ||  (detail.period_config && !detail.period_config.count && detail.on_behalf_limit != 0))){
            await this.userNickname.checkUserName(); //判断是否有昵称              
            this.props.enrollStore.getItemData().then(()=>{
                this.props.history.push('/enrollList')
            })
        }
    }

	// componentDidUpdate(prevProps, prevState){ 
	// 	if(this.state.auto_enroll !== prevState.auto_enroll){					 
	// 		console.log('isFromBack',Config.isFromBack)
	// 		if(this.state.auto_enroll == 1 && !Config.isFromBack){
	// 			let btn = document.querySelector('.enroll-btn')						 
	// 			if(btn){
	// 				btn.click();
	// 			}
	// 		}
	// 	}
	// }
	componentDidMount() {
		Config.isFromBack = false;
		sessionStorage.removeItem('isAwait');		
		sessionStorage.removeItem('teamReqList');
		sessionStorage.removeItem('teamPersonalMsg');	 
		window.addEventListener('popstate',  ()=>{
			Config.isFromBack = true; 		  
		});		
		this.getDetail();	 		
		if (Config.TOKEN) {
			this.props.enrollStore.getUserInfo().catch(() => {});
		}
	}
	componentWillUnmount(){
        if(this.timeDown){
            clearInterval(this.timeDown);
        }		 
    };
	componentWillReceiveProps(nextProps) {
		if(this.props.match.url !== nextProps.match.url) {
			this.getDetail();
		}
	}

	renderHeader(detail) {
		const miniBtnStyle = {
			width: 'calc(100vw - 65px)',
		    height:'40px',
		    background:'#f7f7f7',
			color: '#666666',
			fontSize:12,
			textAlign:'center',
		}

		let signName = WxApi.getDefaultName(detail.sign_name);

		if(detail.auth == 1 && !detail.cert_show){
			signName = WxApi.getDefaultName(detail.sign_name).substr(0,1) + "**";
		}

		return(<div className="d-header">
			<a className="d-header-my" href={withAppBasename('/manage/myEnroll')} onClick={()=>{
				this.props.enrollStore.getCurrMenu(2)
				window._hmt.push(['_trackPageview',  '/manage/myEnroll'])
			}}>
				<img className="left-arrow" src={left_arrow} />
				<span>我的</span>
			</a>
			<div className="d-header-left cursor" onClick={()=>{
				window._hmt.push(['_trackEvent', 'button_to_wx','', '活动详情顶部点击打开小程序按钮', '']); //百度统计				 
				if((!WxApi.isMobile() || WxApi.isOtherEnvironments()) && !WxApi.isWeixn()){ //pc浏览器							 	
					this.showDetailQrCode('block')
				}else if(WxApi.isWeixn() && !Config.TOKEN){					 
					React.$wx.webLogin();
				}else if(!WxApi.isWeixn() && WxApi.isMobile() && !wxapi.isUnionPay()){//手机浏览器							 
					this.getTicket(detail)
				}else if(WxApi.isWeixn() && !WxApi.isMobile()){					 
					this.props.history.push('/h/'+ detail.owner_unionid)
				}				
			}}>
				<img src={detail.owner_pic || Config.defaultAvatar} />
				<h4 className="user-name">{signName}</h4>
				<button className="btn-open-mini" style={{backgroundColor: this.state.themColor}}>去看看</button>
			</div>			
			{
				WxApi.isWeixn() && WxApi.isMobile() ? <div className="btn-open-mini-opacity">
					<wx-open-launch-weapp
							style={miniBtnStyle}
							id="launch-btn"
							username="gh_ae6449501a82"
							path={detail.eid ? this.wxJumpPath : '/pages/default/default.html'}
						>
						<script type="text/wxtag-template">
								<div style={miniBtnStyle}>
								<div>去看看</div>
								</div>
						</script>
					</wx-open-launch-weapp>
				</div> : ''
			}			
		</div>);
	}
	
	// 右侧广告位
	renderWxCode(){
		if(this.state.shareImgUrl){
			return (
				<div className="advert-box-right">
					<div className="wx-code-box">
						<div className="wx-qrcode">
							<img src={this.state.shareImgUrl}></img>
						</div>
						<span>微信扫一扫</span>
						<span className="wx-watch">打开小程序</span>
					</div>
					<a className="create-enroll-box" target="_blank" href="https://www.baominggongju.com/?hmsr=h5">
						<img src={icon_create_enroll} className="icon-create"/>
						<span className="enroll-text">我也要创建活动</span>	
						<img src={icon_right_img} className="icon-right-blue"/>
					</a>								
				</div>
			)
		}
	}
	// 非 VIP 活动在详情页展示白底随机兜底广告。
	renderAdvert(){
		return (
			<div style={{backgroundColor: '#fff', padding: '0 15px 15px'}}>
				<div className="lottery-box" style={{width: '100%', margin: 0, boxSizing: 'border-box'}} onClick={()=>{
					window.open('https://xcx.qunsou.co/recommend.html?appId=wxfaa08012777a431e');
				}}>
					<img className="lottery-banner" src={this.state.lotteryBanner} />
				</div>
			</div>
		)
	}
	// 指定群参加
	renderWxGroup(detail){
		const miniBtnStyle = {
			position: 'absolute',
			left: 0,
			top: 0,
			width: '100%',
			height: '40px',
		}
		return (
			<div class='fixed-group-team' style={{bottom: this.state.show_notice ? '90px' : '50px'}}>
				<div className='group-main' onClick={()=>{
					window._hmt.push(['_trackEvent', 'button_to_wx','', '活动详情顶部点击打开小程序按钮', '']); //百度统计				 
					if((!WxApi.isMobile() || WxApi.isOtherEnvironments()) && !WxApi.isWeixn()){ //pc浏览器							 	
						this.showDetailQrCode('block')
					}else if(WxApi.isWeixn() && !Config.TOKEN){					 
						React.$wx.webLogin();
					}else if(!WxApi.isWeixn() && WxApi.isMobile() && !wxapi.isUnionPay()){//手机浏览器							 
						this.getTicket(detail)
					}else if(WxApi.isWeixn() && !WxApi.isMobile()){					 
						this.props.history.push('/h/'+ detail.owner_unionid)
					}		
				}}>
					<div className='left-box'>
						<img className='msg-img' src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20240221/d542a1fdb85c9cdbe73ec49383ae7924.png"></img>
						<span>{this.state.groupList && this.state.groupList.length > 0 ? this.state.groupList.length : 0}个指定群参加</span>
					</div>
					<span>设置 ></span>
					{
						WxApi.isMobile() && WxApi.isWeixn() ?
						<wx-open-launch-weapp
							id="launch-btn" style={miniBtnStyle}
							username="gh_ae6449501a82"
							path={detail.eid ? this.wxJumpPath : '/pages/default/default.html'}
							>
							<script type="text/wxtag-template">
								<div style={miniBtnStyle}>
									
								</div>
							</script>
						</wx-open-launch-weapp> : null
					}
				</div>
			</div>
		)
	}
	//底部提交通知展示权限：对齐小程序 footermanage.wxml（info_id || admins_node.length || is_owner || sup_vip）
	//发起人/管理员自己未报名（无 info_id）时也要展示通知，H5 兼容 is_admin/admin1/admin3 标记位
	canShowSubmitNotice(detail){
		return !!(detail.info_id
			|| (detail.period && detail.period_info)
			|| Number(detail.is_owner) === 1
			|| Number(detail.is_admin) === 1
			|| Number(detail.admin1) === 1
			|| Number(detail.admin3) === 1
			|| (detail.admins_node && detail.admins_node.length > 0)
			|| Number(detail.sup_vip) === 1);
	}
	//自定义提交通知
	renderNotice(detail){
		// Keep the activity context in the fallback URL while router navigation preserves MobX detail state.
		const noticeHref = withAppBasename('/notice?eid=' + encodeURIComponent(detail.eid || ''));
		//对齐小程序 detailnotice follow 分支：权限项为 info_id/on_behalf/is_owner/is_admin/sup_vip，发起人/管理员未报名也可见
		let followPerm = this.canShowSubmitNotice(detail) || detail.on_behalf == 1;
		let showScene = (detail.follow.scene == 0 && followPerm) || (detail.follow.scene == 1 && detail.verify == 1 && detail.verified == 1) || (detail.follow.scene == 2 && followPerm || (detail.verify ==1 && detail.verified == -1));
		if(detail.follow.scene != 2 && detail.queue == 1 && detail.verified == -1){ //排队中且展示场景非提交成功和排队中
			showScene = false;
		}
		 
		const {wxNotice} = this.props.myEnrollStore;
		let noticeArr = wxNotice.msg_list;
		let sms_list = wxNotice.sms_list;
		if(noticeArr && noticeArr.length > 0){
			noticeArr = noticeArr.filter(item => !item.time_out || item.time_out == 0);
		}
		const miniBtnStyle = {
			width: '414px',
		    height:'40px',
		    background:'#f7f7f7',
		}
		if(noticeArr && noticeArr.length > 0 &&  noticeArr[0].content && this.canShowSubmitNotice(detail)){
			return(
				<div className="notice-body-panel">
					<a className="notice-box" href={noticeHref} onClick={(event) => {
							event.preventDefault();
							sessionStorage.setItem("noticeTab",0);
							this.props.history.push('/notice?eid=' + encodeURIComponent(detail.eid || ''));
						}}>
						<img className='notice-icon' src={ic_top_notice} />
						<p className='notice-content'>{noticeArr[0].content}</p>
						<img className='icon-row' src={ic_top_row} />
					</a>
					{this.state.isWeixin ? <div className="notice-box-opacity">
					<wx-open-launch-weapp
						  id="launch-btn"
						  username="gh_ae6449501a82"
						  path={detail.eid ? this.wxJumpPath + '&open_type=notice' : '/pages/default/default.html'}
						>
						<script type="text/wxtag-template">
							 <div style={miniBtnStyle}>
								
							 </div>
						</script>
					</wx-open-launch-weapp>
				</div> : null}
				</div>
			)
		}else if(sms_list && sms_list.length > 0){
			return (
				<div className="notice-body-panel">
					<a className="notice-box" href={noticeHref} onClick={(event) => {
								event.preventDefault();
								sessionStorage.setItem("noticeTab",0);
								this.props.history.push('/notice?eid=' + encodeURIComponent(detail.eid || ''));
							}}>
							<img className='notice-icon' src={ic_top_notice} />
							<p className='notice-content'>{sms_list[0].content}</p>
							<img className='icon-row' src={ic_top_row} />
						</a>
						{this.state.isWeixin ? <div className="notice-box-opacity">
						<wx-open-launch-weapp
							id="launch-btn"
							username="gh_ae6449501a82"
							path={detail.eid ? this.wxJumpPath + '&open_type=notice' : '/pages/default/default.html'}
							>
							<script type="text/wxtag-template">
								<div style={miniBtnStyle}>
									
								</div>
							</script>
						</wx-open-launch-weapp>
					</div> : null}
				</div>
			)
		}else if(detail && detail.follow && detail.follow.type > 0 && (detail.follow.desc||detail.follow.qrcode||detail.follow.link_url) && showScene){
			return(
				<div className="notice-body-panel">
					<a className="notice-box" href={noticeHref} onClick={(event) => {
							event.preventDefault();
							sessionStorage.setItem("noticeTab",1);
							this.props.history.push('/notice?eid=' + encodeURIComponent(detail.eid || ''));
						}}>
						<img className='notice-icon' src={ic_top_notice} />
						<p className='notice-content'>{ detail.follow.desc || '已参加活动的小伙伴，请点击查看'}</p>
						<img className='icon-row' src={ic_top_row} />
					</a>
					{ this.state.isWeixin ? <div className="notice-box-opacity">
						<wx-open-launch-weapp
							  id="launch-btn"
							  username="gh_ae6449501a82"
							  path={detail.eid ? this.wxJumpPath + '&open_type=notice&notice_type=1' : '/pages/default/default.html'}
							>
							<script type="text/wxtag-template">
								 <div style={miniBtnStyle}>
									
								 </div>
							</script>
						</wx-open-launch-weapp>
					</div> : null }
				</div>
			)
		}
	}

	//banner图片
	renderBanner(detail) { 
		let imgHeight = document.body.offsetWidth * 0.6;		
		if(detail.banner) {			
			return(<div className="Detail-header-image">
                <img className='enroll-detail-img' onClick={() => {
                    React.$wx.previewImage({
                        current: detail.banner, // 当前显示图片的http链接
                        urls: [detail.banner] // 需要预览的图片http链接列表
                    });
                }} src={WxApi.getAutoImage(detail.banner, 750, 'single')} />
            </div>);
		}else if(detail.video && detail.video.url){
			return(<div className="Detail-header-image" style={{height: imgHeight}}>
			<video className="video-banner" src={detail.video.url} controls="controls" poster={detail.video.pic_url}></video>
			</div>);
			
		}else if(detail.banner === null){
			return (<div className="Detail-header-image"><div className='enroll-detail-img'></div></div>)
		}
		else {
			return(<div className="no-banner"></div>);
		}
	}
 
	//活动内容
	renderContent1(detail) {
		let enrollStore = this.props.enrollStore;		 	 
		const listItem = [{
				img: 'https://cdn-xcx-qunsou.weiyoubot.cn/material/20220411/ccdf4a2dcf25fb1516eb860f259ff0d6.png',
				isShow: true,
				title: "报名：",
				content: detail.startTime + " - " + detail.endTime,
				isTime: true,
				dateTime: detail.end_time ? new Date(detail.end_time * 1000).toISOString() : '',
			},
			{
				img: 'https://cdn-xcx-qunsou.weiyoubot.cn/material/20220411/6cd639fd139836f17cf134f6e290ec10.png',
				isShow: (detail.user_visible || detail.is_owner)&& detail.temp != 8 && detail.temp != 10,
				title: "提交：",
				content: ((detail.user_visible || detail.admin1 == 1 || detail.is_owner) ? detail.count : '**') + "/" + (detail.limit ? detail.limit : "无限制") + " ",
			},
			{
				img: 'https://cdn-xcx-qunsou.weiyoubot.cn/material/20220411/354236005ef43fa149a8a80d09942f7b.png',
				isShow: !!detail.act_start,
				title: "活动：",
				content: detail.actStartTime + " - " + detail.actEndTime
			},
			{
				img: 'https://cdn-xcx-qunsou.weiyoubot.cn/material/20220411/5d5a06f07bf908516ba4af0f3c939764.png',
				isShow: !!detail.address,
				title: "地址：",
				content: detail.address, //TODO 这里需要添加定位,
				action: () => {
					if(!detail.address_type || detail.address_type ==0){
						if(WxApi.isMobile() && WxApi.isWeixn()){
							if(!Config.TOKEN){
								React.$wx.webLogin();
								return;
							}
							window.wx.openLocation({
								latitude: detail.latitude, // 纬度，浮点数，范围为90 ~ -90
								longitude: detail.longitude, // 经度，浮点数，范围为180 ~ -180。
								address: detail.address, // 地址详情说明
								scale: 28, // 地图缩放级别,整形值,范围从1~28。默认为最大
							});
						}else{
							const linkElement = document.createElement('a');
							linkElement.target="_blank";
							linkElement.href = `https://apis.map.qq.com/uri/v1/marker?marker=coord:${detail.latitude},${detail.longitude};title:活动地址;addr:${detail.address}&referer=myapp`
							// linkElement.href = `https://api.map.baidu.com/marker?location=${detail.latitude},${detail.longitude}&title=活动地址&content=${detail.address}&output=html&src=地图&ak=G1RjyBHcccDk6pb865C4FrPXjcpB2eKM`						
							const clickEvent = new MouseEvent('click', {
								view: window,
								bubbles: true,
								cancelable: true
							});							
							linkElement.dispatchEvent(clickEvent);
						}						
					}else{
						this.setState({showLink:true});
					}
					
				}
			},
			{
				img:'https://cdn-xcx-qunsou.weiyoubot.cn/material/20220411/24b2000097834bc5092203da00c8e00e.png',
				isShow:detail.period,
				title:'周期：',
				content:`${detail.period == 1 ? "按天报名" : "按周报名"} ${detail.daily_time ? "(每天" + detail.daily_start + "~" + detail.daily_end + "可报名)" : ""}`
			},

		];
		let  has_price = false
		if(detail.fee > 0 || detail.items_fee && detail.items_fee.fee > 0 || (detail.items_fee.vip_card_id && detail.items_fee.vip_fee > 0)){
			has_price = true
		}	 
		return(
			<section className="Detail-content1">
                <h1 className="Detail-title">
                    {detail.title}
                </h1>
				{
					detail.sub_mchid_type == 'offline' && !has_price ? <div className='offline-amount'>另行收款</div> : null
				}
                <Flex className="Detail-subtitle" align={"around"}>
					<div>						
							{
								this.renderEnrollFee(detail)
							}					 										 			
						<div style={{display:'flex'}}>
							{
									
								enrollStore.statusText.map((item, index) => {
									return(
										<Flex.Item key={index} className={"SubTitleTag " + enrollStore.tagClassName}>
											{item == '进行中' && (detail.count === detail.limit && detail.limit !== 0) ? '名额已满' : item}
										</Flex.Item>
									)
									
								})
							}	
							{
								detail.info_id && detail.status == 2 ? <div className="SubTitleTag tag-end">已提交</div> : null
							}							
						</div>
					</div>
					<button className="detail-notice-btn" style={{color:this.state.themColor}} onClick={() => {
							if(detail.is_fans){					
								this.child.setDialog('open')
							}else{
								window.location.href = 'https://mp.weixin.qq.com/s/7xoT8N4jJuR36X3UoZEQVg'
							}
						}}>						
						<span>订阅&nbsp;</span>
						<i className="notice-icon iconfont icon-svg45-copy" style={{color:this.state.themColor}}></i>
					</button>                   
                </Flex>
				
                <Flex className="Detail-content" direction={"column"} align={"start"} justify={"center"}>
                    {
                        listItem.map((item, index) => {
                            if (item.isShow) {
                                return (
                                    <Flex.Item key={index} className="Detail-content-text">
                                        <img src={item.img}/>
                                        <div className="Detail-content-right">
											{ !this.state.isVertical ? <span>{item.title}</span> : null }	                              
	                                        {
	                                        	item.isTime ?
	                                        	<time className={item.action ? "action" : ""} dateTime={item.dateTime}>{item.content}</time>
	                                        	:
	                                        	<span className={item.action ? "action" : ""} onClick={() => {
	                                            	if (item.action) {
	                                                	item.action();
	                                            	}
	                                        	}}>{item.content}</span>
	                                        }
                                        </div>
                                    </Flex.Item>
                                )
                            }
                        })
                    }

                </Flex>
            </section>
		)
	}
	
	renderEnrollFee(detail){
		if(detail.items_fee && (detail.items_fee.fee > 0 || (detail.items_fee.vip > 0 && detail.items_fee.vip_card_id)) || (detail.items_fee.vip_pay_setting && detail.items_fee.vip_pay_setting.length)){	
			let text = '';
			if(detail.items_fee.vip_pay_setting && detail.items_fee.vip_pay_setting.length){
				text = detail.items_fee.vip_pay_setting.map((data, index)=>{
					return (
						<div className="vip-price-panel" key={index} onClick={()=>{
							React.$wx.jumpNewPath.call(this,'/apply-vip?cid='+data.vip_card_id)
						}}>   
							<span>{ data.card_type == 1 ? '￥' + data.fee/100 : '扣'+data.card_cert_num + '次'}<span className='gray-text-tips'>会员价</span></span>                                 								 
						</div>
					)
				})
			}else if(detail.items_fee.vip_card_id){
				text = <div className="vip-price-panel" style={{marginLeft:detail.items_fee.fee ? '12px':'0'}} onClick={()=>{
						React.$wx.jumpNewPath.call(this,'/apply-vip?cid='+detail.items_fee.vip_card_id)
					}}>		
						{
							detail.items_fee.card_cert_num > 0 ? 
							<span>扣{detail.items_fee.card_cert_num}次<span className='gray-text-tips'>会员价</span></span> 
							: <span>￥{detail.items_fee.vip_fee / 100}<span className='gray-text-tips'>会员价</span></span>
						}								
					</div> 
			}		
			return (
				<div className="enroll-price-panel">
					<div className="price-panel cursor">		
						{ detail.items_fee.fee ? <div className="new-price">￥<span className="price-num">{detail.items_fee.fee / 100}</span></div> : null}			 						 						 															 
						{ text }						 
					</div>
				</div>				
			)
		}
	}

	//输出发起人相关信息
	renderOwner(detail) {
		let icon = null;
		//let text = detail.is_owner ? "非VIP" : "";
		let text = "";
		let signName = detail.sign_name;				 
		switch(detail.auth) {
			case 1:
				icon = img_identification_p;
				text = "个人";
				if(!detail.cert_show){
					let nameArr = detail.sign_name.toString();
					signName = nameArr[0] + '**';
				}
				break;
			case 2:
				icon = img_identification_c;
				text = "机构";
				break;
			case 3:
				icon = img_identification_c;
				text = "机构";
				break;
			case 4:
				icon = img_identification_g;
				text = "公众号";
				break;
			default:
				icon = null;
				break
		}		
		return(
			<section className="Detail-role-panle">
			<div className="Detail-originator">
				<div className="originator-info-panel">	
					<a className="originator-info" href={withAppBasename('/h/' + detail.owner_unionid)} onClick={()=>{
								window._hmt.push(['_trackEvent', 'button_to_homepage','', '活动详情点击主页', '']); //百度统计
							}}>
						<div className='detail-originator-left'>
							<img className='min-img-header' src={detail.owner_pic || Config.defaultAvatar}/>
							<div className="originator-type">
								<h3 className="originator-top">
									{WxApi.getDefaultName(signName)}
								</h3>
								<div>
									{
										detail.auth > 0 && detail.role ? <div style={{backgroundColor: this.state.themColor}} className="auth-type-parent">
											<img className="auth-icon" src={ic_person_identity} />
											<label>{text}</label>
										</div> : null
									}
									<div className='send-message' onClick={(e)=>{
										e.preventDefault()
										e.stopPropagation()
										if(!Config.TOKEN){
											React.$wx.webLogin()
										}else if(!WxApi.isWeixn() && WxApi.isMobile() && !wxapi.isUnionPay()){
											this.getTicket(detail)
										}else{							
											WxApi.setMessageUserStyle(detail.user_style);
											this.props.history.push('/message')							
										}
									}}><i className="iconfont icon-xinxi"></i>&nbsp;留言</div>
								</div>
								
							</div>
						 </div>
						{
							 
							<div className="detail-originator-right">
								主页
							 	<img className="arrow-share" src={right_arrow} />
							 </div> 
						}
						
					</a>
				</div>								
				
				{ detail.summary ? <div className='owner-desc'>{detail.summary}</div>  : ''}							
            </div>
            </section>
		)
	}

	// 消息订阅弹窗
	renderMsgDialog(detail){
		let signName = detail.sign_name;
		if(detail.auth == 1 && !detail.cert_show){
			let nameArr = detail.sign_name.toString();
			signName = nameArr[0] + '**';
		}
		return <NewMsgDialog ref="messageDom" signName={signName} owner_pic={detail.owner_pic || Config.defaultAvatar} sub_user={this.state.sub_user} 
		owner_unionid={detail.owner_unionid} onRef={(ref)=>{ this.child = ref}}/>
	}

	// 联合创作
	renderEnrollGroup(detail){
		let list = {					
			1:'共创',
			2:'嘉宾',
			3:'联名',
			4:'赞助',
			5:'联名'
		}
		return (
			<ul class="team-user-panel">
				<li className='team-list' onClick={()=>{
					React.$wx.jumpNewPath.call(this,'/h/'+detail.owner_unionid);
				}}>
					<div class="team-avatar">
						<img class="team-img" src={detail.owner_pic || Config.defaultAvatar} />
						<span class="team-tag">发起</span>	
						<img class="auth-icon" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230705/872afef5e0be594e97fd9eaaf60f5fd1.png"></img> 
					</div>
					<span class="team-uname">{WxApi.getDefaultName(detail.sign_name)}</span>	
				</li>
				{
					detail.team_user.map((item,index)=>{
						return (
							index < 3 ? 
							<li class="team-list" key={index} onClick={()=>{
								React.$wx.jumpNewPath.call(this,'/h/'+item.unionid);
							}}>				
								<div class="team-avatar">
										<img class="team-img" src={item.upic || Config.defaultAvatar} />
										<span class="team-tag">{list[item.type]}</span>	
										{
											item.is_auth ? 
											<img class="auth-icon" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230705/872afef5e0be594e97fd9eaaf60f5fd1.png"></img> : ''
										}										
								</div>				
								<span class="team-uname">{item.uname}</span>											 			 
							</li> : ''							
						)
					})
				}
			</ul>
		)
	}
	
	//获取描述内容
	getContent(detail){		
		if(detail.content && detail.content !="无"){
			return(<pre className="Detail-describe-img">{detail.content}</pre>)
		}else{
			return(<div className="nullData"></div>)
		}
	}

	//输出描述
	// Keep the description and non-VIP advertisement in one white content block.
	renderDescribe(detail, showAdvert) {
		let enrollStore = this.props.enrollStore;
		return(
			<section className="Detail-describe-section">
			<Flex className="Detail-describe" direction={"column"} style={{'marginBottom': showAdvert ? 0 : (detail.content && detail.content.length ? '10px' : 0)}}>
				{
					detail.content ? <Flex.Item className={"Detail-describe-content" }>
					{
							Array.isArray(detail.content) ? detail.content.map((item, index)=>{
								const style = {
								 color: item.color || '#333',
								 fontSize: item.font_size / 2 || 17 + 'px',
								 textAlign: item.text_align || 'left',
								 fontWeight: item.font_weight || 'normal'
 
							 }
								if(item.type == "text" && item.value){
									 if(index == 0){
										let description = item.value.substring(0,100)
										document.getElementsByTagName('meta')[4].setAttribute("content",description)
									 }
									 
									 return(<pre className="Detail-describe-img" key={index} style={style}>{item.value}</pre>)
								 }else if(item.type == "img" || item.type == 'img_hd'){
									 return(<div className="Detail-describe-img detail-img" key={index}><img onClick={() => {
											  React.$wx.previewImage({
												  current: item.value, // 当前显示图片的http链接
												  urls: [item.value]// 需要预览的图片http链接列表
											  });
										  }} src={item.value} /></div>)
								 }
								 else if (item.type == "file"){
									let colorType = 'bg-default';
									let fileList = {
										'W':'bg-blue',
										'doc':'bg-blue',
										'X':'bg-green',
										'pdf':'bg-red',
										'P':'bg-orange'
									}
									if(fileList[item.file_type]){
										colorType = fileList[item.file_type];
									}									
									let file_index = item.name.lastIndexOf('.');				
									return(<div onClick={() => {
										if(item.download == 1){ //只可查看不可下载
											if((!WxApi.isMobile() || WxApi.isOtherEnvironments()) && !WxApi.isWeixn()){ //pc浏览器					
												this.showDetailQrCode('block');
											}else if(WxApi.isWeixn() && !Config.token){
												React.$wx.webLogin();
											}else if(!WxApi.isWeixn() && WxApi.isMobile() && !wxapi.isUnionPay()){//手机浏览器				
												this.getTicket(detail);
											}										
										}else{
											window.location.href = item.url;
										}										
									}} className="rule-file-item">
										<div className={["rule-file-type "+colorType].join('')}>{item.file_type}</div>
										<div className="rule-file-name">{file_index > -1 ? item.name.substring(0,file_index) : item.name}</div>
										{
											item.download != 1 ? <img className='down-btn' src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230426/0632028fda6d1c479fab874370e9fa80.png"></img> : ''
										}										
										{
											WxApi.isWeixn() && WxApi.isMobile() && item.download == 1 ?
											<wx-open-launch-weapp												
												id="jump-wx-btn"
												username="gh_ae6449501a82"
												path={detail.eid ? this.wxJumpPath : '/pages/default/default.html'}
												>																						
												<script type="text/wxtag-template">
													<div style={{width:'100%',height:'60px'}}></div>
												</script>																				
											</wx-open-launch-weapp> : ''
										}											
									</div>)
								 }else if(item.type == 'url'){
									 return (
										 <div className="article-box" onClick={()=>{
											 window.location.href = item.link;
										 }}>
											 <img src={item.icon} className="article-img"></img>
											 <p className="article-title">{item.value}</p>
										 </div>
									 )
								 }else if(item.type == 'adress'){
									 return (
										<div className='adress-box' onClick={()=>{
											if(WxApi.isMobile() && WxApi.isWeixn()){
												if(!Config.TOKEN){
													React.$wx.webLogin();
													return;
												}
												window.wx.openLocation({
													latitude: item.latitude, // 纬度，浮点数，范围为90 ~ -90
													longitude: item.longitude, // 经度，浮点数，范围为180 ~ -180。
													address: item.value, // 地址详情说明
													scale: 28, // 地图缩放级别,整形值,范围从1~28。默认为最大
												});
											}else{
												const linkElement = document.createElement('a');
												linkElement.target="_blank";
												linkElement.href = `https://apis.map.qq.com/uri/v1/marker?marker=coord:${item.latitude},${item.longitude};title:地址;addr:${item.value}&referer=myapp`
												// linkElement.href = `https://api.map.baidu.com/marker?location=${detail.latitude},${detail.longitude}&title=活动地址&content=${detail.address}&output=html&src=地图&ak=G1RjyBHcccDk6pb865C4FrPXjcpB2eKM`						
												const clickEvent = new MouseEvent('click', {
													view: window,
													bubbles: true,
													cancelable: true
												});							
												linkElement.dispatchEvent(clickEvent);
											}														 
										 }}>
											<img src={icon_adress} className="adress-img" />
											<span> {item.value}</span>
										 </div>
									 )
								 }else if(item.type == 'video'){
									 return (
										<video width="320" height="240" controls="controls" style={{display:'block',margin:'10px auto'}}>
											<source src={item.value} type="video/mp4" />
										</video>
									 )
								 }else if(item.type == 'copy'){
									 return (
										<div className="copy-box applet-box flex-between-box" onClick={()=>{
											WxApi.copeText(item.value)
											Toast.success('复制成功')							
										}}>											 
											<img className="applet-img" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230220/bbc74473a300035bee8247e1037e4adb.png" />
											<div className="applet-content">												
												<p className="copy-desc">{item.desc}</p>												
												<span>{item.value}</span>																							
											</div>
											<Button type="primary" className="open-btn">复制</Button>
										</div>
									 )
								 }else if(item.type == 'program'){
									const miniBtnStyle = {
										display:'inline-block',
										width:'70px',
										height:'28px',
										padding:'10px 0',																	
										position:'absolute',
										right: '10px',
										top:'7px',
										zIndex:"10"					
									}
									let defaultAppLog = "https://cdn-xcx-qunsou.weiyoubot.cn/material/20230220/4bb82882884598314f9ab20e78f55328.png";
									return (
										<div className="applet-box flex-between-box">  
											<img className="applet-img" src={item.logo||defaultAppLog} />                     											
											<div className="applet-content">
												<span>{item.value}</span>
												<p className="applet-desc">{item.desc}</p>
											</div>
											<Button type="primary" className="open-btn" onClick={()=>{
												if(item.mini_type > 0){
													window.open(item.path);
												}else if(!Config.TOKEN){
													React.$wx.webLogin();
												}											
											}}>打开</Button>
											{
												item.mini_type == 0 && Config.TOKEN ? 
												<wx-open-launch-weapp id="launch-btn" style={miniBtnStyle} username={item.originalId} path={item.path}>
													<script type="text/wxtag-template">														
														<span type="primary" style={miniBtnStyle}></span>												
													</script>
												</wx-open-launch-weapp> : ''
											}																				
										</div>
									)
								 }else if(item.type == 'channel'){
									return (
										<div className="channel-box">
											<img className="channel-img" src={icon_video_img}/>                      
											<span>{item.value}</span>
										</div>
									)
								 }else if(item.type == 'audio'){
									return (
										<div className="audio-box">
											<div className="audio-main" onClick={()=>{
												 if(this.state.currAudioIndex == index){
													this.audioBox.pause();
													this.state.currAudioIndex = -1;
												}else{
													if(!this.audioBox){
														this.audioBox = new Audio();
													}
													this.audioBox.src = item.path;
													this.audioBox.addEventListener('ended',()=>{ //语音播放完毕
														this.setState({ currAudioIndex: -1 });                
													});
													this.audioBox.play();													 
													this.setState({ currAudioIndex: index });
												} 
											}}>     
												{
													index == this.state.currAudioIndex ?
													<img className="audio-play-img" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230706/46e95d5bad6311ee3baa23f62f144377.gif"></img>
													:
													<img className="audio-play-img" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230706/2f2983dd7572c12401096261d73bea12.png"></img>
												}
												<span>{item.duration}″</span>
											</div>                        
										</div>  
									)
								}									
							}):this.getContent(detail)
					}
					   {
						   // <div className="show-more-btn">展开更多</div>
					   }
				 </Flex.Item>:null
				}
            </Flex>
			</section>
		)
	}
	
	//口令输入框
	renderTokenPanel(detail){
		return(
			<Flex className="Detail-join-token" style={{display:this.state.tokenPanel}}>
				<div className="share-choice-mask" onClick={() => {this.setTokenType('none') }}></div>
					<div className="minProgram-panel">
					<div className="read-main">
						<div className="panel-title">输入口令</div>
						{detail.has_token == 1&&detail.token_desc ? <div className="cen-token" style={{whiteSpace:'pre-wrap'}}>口令获取方法：{detail.token_desc}</div> : null}
						<div className="token-input-panel">
							<InputItem className="token-input" value={this.state.token} onChange={(value) => this.onChange(value)} placeholder='请输入口令' />
						</div>
						<div className="sure-btn-panel flex-start-box">
							<Button className="btn-cancel" onClick={() => { this.setTokenType('none') }} >取消</Button>
							<Button className="btn-get-token" type="primary" onClick={() => { this.submitToken(1,detail) }} >确定</Button>
						</div>
						{/* <div className="token-desc">活动发起人要求必须输入正确口令才能报名,如有问题,请与TA联系。 </div> */}
					</div>
				</div>
			</Flex>
		)
	}

	//提交前阅读框
	renderSubmitRead(detail){
		return(
			<div>
				{this.state.showReadDialog?( 
				<Flex className="Detail-join-token">
				<div className="share-choice-mask" onClick={()=>{this.setReadDialog(false)}}></div>
				<div className={`minProgram-panel read-box` }>
					<div className="read-main">
						<div className="panel-title">{detail.token_desc.title}</div>
						<div className='read-content'>
							<p className="read-text" style={{whiteSpace:'pre-wrap'}}>{detail.token_desc.content}</p>							
							{
								detail.token_desc && detail.token_desc.pics && detail.token_desc.pics.length ? 
								detail.token_desc.pics.map(item=>{
									return <img className='read-img' src={item.url} onClick={()=>{
										let pics = detail.token_desc.pics.map(item=>item.url);
										React.$wx.previewImage({
											current: item.url, // 当前显示图片的http链接
											urls: pics // 需要预览的图片http链接列表
										})
									}}></img>
								}) : ''
							}							
						</div>				
						{ detail.token_desc.feedback == 2 ? 
							<div>
								<div className="token-input-panel">
								<InputItem className="token-input" value={this.state.token} placeholder={`请手动输入“${detail.token_desc.reaction}”`} onChange={(value) => this.onChange(value)}/>
								</div>
								<div className="sure-btn-panel">
								<Button className="btn-get-token" type="primary" onClick={() => { this.submitToken(2,detail) }} >确定</Button>
								</div>
							</div>
							:  
							<div className="sure-btn-panel">
								{detail.token_desc.feedback == 0?
								<Button className="btn-get-token" type="primary" onClick={() => { this.handleSubmit(detail) }} >我已知晓</Button>
								:
								<Button className="btn-get-token" type="primary" disabled={this.state.countDown>0} onClick={() => { this.handleSubmit(detail) }} >我已知晓{this.state.countDown ==0?'':`(${this.state.countDown})`}</Button>
								}
							</div>						 
						}
					</div>
					
				</div>
			</Flex>)
			:null}
		</div>
		)
	}
	
	submitToken(type,detail){
		this.props.myEnrollStore.subToken(this.state.token).then(() => {
			let {tokenPass} = this.props.myEnrollStore;
			if(tokenPass){
				this.setTokenType('none');
				this.setState({
					showReadDialog:false,
					token:''
				})
				if(detail.temp == 10){
					this.setState({
						showSeat: true,
					})
				}else if(detail.temp == 8){
					this.setState({
						showReverse: true,
					})
				}else{
					this.props.history.push('/enrollForm')
				}
			}else{
				if(type == 1){
					Toast.fail('口令错误', 2);
				}else{
					Toast.fail('输入内容错误', 2);
				}
				
			}
		});
	}
	
	handleSubmit(detail){
		this.setState({
			showReadDialog:false
		})
		if(detail.temp == 10){
			this.setState({
				showSeat: true,
			})
		}else if(detail.temp == 8){
			this.setState({
				showReverse: true,
			})
		}else{
			this.props.history.push('/enrollForm')
		}
	}

	onChange(value){
		this.setState({
	        token: value,
	    })
	}

	setValue(value){
		this.setState({
	        reaction: value,
	    })
	}

	setTokenType(type){
		this.setState({
	        tokenPanel: type,
	    })
	}

	setReadDialog(type){
		clearInterval(this.timer)
		this.setState({
			showReadDialog:type
		})
	}
	gotoEnroll(detail, index, item){		 	 
		if(item && item.key){ //如果有分类，则索引需要进行匹配
			let i = detail.items.findIndex(data=>data.key == item.key);
			if(i > -1){ index = i };
		}
		window.reserve_index = index;
		this.props.myEnrollStore.setItemIndex(index);
		this.props.myEnrollStore.setCurrentEnroll(0);
		if(detail.has_token == 1){
			this.setTokenType('block');
			detail.token_desc = detail.token_desc.replace(/\n/g, '\n')
		} else if(detail.has_token == 2){
			detail.token_desc.content = detail.token_desc.content.replace(/\n/g, '\n')
			this.setReadDialog(true)
			this.timer = setInterval(()=>{
				if(this.state.countDown<=0){
					this.state.countDown = 0
					clearInterval(this.timer)
				}else{
					this.state.countDown--
				}
				this.setState({
					countDown:this.state.countDown
				})
			},1000)
		}else{
			if(detail.temp == 10){
				this.setState({
					showSeat: true,
				})
			}else if(detail.temp == 8){
				this.setState({
					showReverse: true,
				})
			}else{
				this.props.history.push('/enrollForm')
			}
			
			
		}
	}

	//相关逻辑
	renderButton(detail) {
		let btnColor = {
			backgroundColor:"#00a8f3"
		}
		if(detail && detail.btn_config && detail.btn_config.color){
			btnColor.backgroundColor = detail.btn_config.color;
		}
		if(detail.info_id){ //旁边有查看凭证图标时，需要调整按钮位置
			btnColor.paddingLeft = '10px';
		}		
		let { timeInfo } = this.state;
		if(Config.TOKEN){
			let isEditor = detail.period_config && detail.period_config.day_type == 'all' && detail.period_config.count == 1; //如果是总共一次，则显示编辑按钮
			if(detail.status == 2 && !detail.info_id && detail.on_behalf == 0) {
				return(<Button type="primary" style={btnColor} onClick={()=>{
					this.props.myEnrollStore.setCurrentEnroll({info_id: detail.info_id});
					this.props.history.push('/cert');
				}}>已截止</Button>)
			}else if(detail.status == 0) {
				return(<Button type="primary" className='detail-submit-btn' style={btnColor} onClick={()=>{
					this.props.myEnrollStore.setCurrentEnroll({info_id: detail.info_id});
					this.props.history.push('/cert');
				}}>
					<span>未开始</span>
				{
					!this.state.isHideBtn && detail.btn_config && (detail.btn_config.btn_cd == 1 || detail.btn_config.btn_cd == 2) ? 
					<span className="cen-countdown">剩余{timeInfo.hour}小时{timeInfo.minute}分钟{timeInfo.second}秒</span> : ''
				}</Button>)
			}else if (detail.temp == 8 && !detail.info_id) {
				return (<Button type="primary" style={btnColor} className="btn-my-reserve enroll-btn" onClick={async () =>{
					if(detail.sub_user_setting && detail.sub_user_setting.length && detail.sub_user_setting.indexOf('all') == -1 && detail.sub_user_setting.indexOf('white') == -1){						 
						if((detail.sub_user_setting.indexOf('vip') != -1 && this.state.vipList.length > 0) || (detail.sub_user_setting.indexOf('fans') != -1 && detail.sub_user)){
							await this.getEnrollStatus(detail)
							this.props.enrollStore.getItemData().then(()=>{
								this.props.myEnrollStore.setMyEnrollList([])
								this.setReverseTag(detail) //预约项目
								this.setState({
									showReverse: true,
								})
							})
							return
						}else if(detail.sub_user_setting.indexOf('fans') != -1 && !detail.sub_user){
							Modal.alert('温馨提示','你还不是当前组织的粉丝，不能参加此活动，请先去关注活动组织者', [
								{ text: '取消', style: 'default'},
								{ text: '去关注', onPress: () => {	
									React.$wx.jumpNewPath.call(this,'/h/'+sessionStorage.getItem('owner_unionid'))
								} },
							])
							return
						}else if(detail.sub_user_setting.indexOf('vip') != -1 && !this.state.vipList.length){
							Modal.alert('需先获取会员卡','本活动仅限持有会员卡的用户提交，请点击获取会员卡了解详细内容', [
								{ text: '取消', style: 'default'},
								{ text: '获取会员卡', onPress: () => {	
									let cid = detail.items_fee && detail.items_fee.vip_card_id ? detail.items_fee.vip_card_id : ''
									React.$wx.jumpNewPath.call(this,'/apply-vip?cid='+ cid)
								} },
							])
							return
						}else if(detail.sub_user_setting.indexOf('end_all') != -1){
							Modal.alert('温馨提示','发起人设置了所有人不可提交，暂时无法提交', [
								{ text: '取消', style: 'default'},
								{ text: '去留言', onPress: () => {	
									React.$wx.jumpNewPath.call(this,'/message')
								} },
							])
							return
						}			 
					}
					await this.getEnrollStatus(detail)
					await this.userNickname.checkUserName(); //判断是否有昵称
					this.props.enrollStore.getItemData().then(()=>{
						this.props.myEnrollStore.setMyEnrollList([])
						this.setReverseTag(detail) //预约项目
						this.gotoEnroll(detail)						
					})									
				} }>立即预约</Button>)	
			}else if((detail.count >= detail.limit && !detail.info_id && detail.on_behalf==0 && detail.limit!=0 && detail.queue && (detail.temp != 5 || !(detail.items && detail.items.length > 0))) || (detail.temp == 5 && detail.items && detail.items.length > 0 && detail.no_quoto && !detail.info_id && detail.on_behalf==0 && detail.queue)){
				return(<Button type="primary" style={btnColor} onClick={async () =>{
					await this.getEnrollStatus(detail)
					this.props.enrollStore.getItemData().then(()=>{
						this.gotoEnroll(detail)
					})
				} 
			}>排队候补</Button>)				
			}else if((detail.count >= detail.limit && !detail.info_id && detail.on_behalf == 0 && detail.limit != 0) || (detail.temp == 5 && !detail.info_id && detail.no_quoto && !detail.queue)) { //名额已满
				return(<Button type="primary" style={btnColor} onClick={()=>{
					this.props.myEnrollStore.setCurrentEnroll({info_id: detail.info_id});
					this.props.history.push('/cert');
				}}>{detail.btn_config && detail.btn_config.text ? detail.btn_config.text : this.state.btnTypeText[detail.btn_type]}</Button>)
			}else if((detail.status == 1 && ((!detail.info_id && !detail.period) || (detail.period == 1 && !detail.period_info) ) && detail.on_behalf == 0) || (detail.on_behalf && (detail.pay_status == 1 || detail.pay_status == 2))) {
				return <Button type="primary" className='detail-submit-btn enroll-btn' style={btnColor} onClick={async()=>{
					if(detail.sub_user_setting && detail.sub_user_setting.length && detail.sub_user_setting.indexOf('all') == -1 && detail.sub_user_setting.indexOf('white') == -1){						 
						if((detail.sub_user_setting.indexOf('vip') != -1 && this.state.vipList.length > 0) || (detail.sub_user_setting.indexOf('fans') != -1 && detail.sub_user)){
							await this.getEnrollStatus(detail)					
							this.props.enrollStore.getItemData().then(()=>{
								this.gotoEnroll(detail)
							})
							return
						}else if(detail.sub_user_setting.indexOf('fans') != -1 && !detail.sub_user){
							Modal.alert('温馨提示','你还不是当前组织的粉丝，不能参加此活动，请先去关注活动组织者', [
								{ text: '取消', style: 'default'},
								{ text: '去关注', onPress: () => {	
									React.$wx.jumpNewPath.call(this,'/h/'+sessionStorage.getItem('owner_unionid'))
								} },
							])
							return
						}else if(detail.sub_user_setting.indexOf('vip') != -1 && !this.state.vipList.length){
							Modal.alert('需先获取会员卡','本活动仅限持有会员卡的用户提交，请点击获取会员卡了解详细内容', [
								{ text: '取消', style: 'default'},
								{ text: '获取会员卡', onPress: () => {	
									let cid = detail.items_fee && detail.items_fee.vip_card_id ? detail.items_fee.vip_card_id : ''
									React.$wx.jumpNewPath.call(this,'/apply-vip?cid='+cid)
								} },
							])
							return
						}else if(detail.sub_user_setting.indexOf('end_all') != -1){
							Modal.alert('温馨提示','发起人设置了所有人不可提交，暂时无法提交', [
								{ text: '取消', style: 'default'},
								{ text: '去留言', onPress: () => {	
									React.$wx.jumpNewPath.call(this,'/message')
								} },
							])
							return
						}						 
					}
					if(detail.period_config && detail.period_config.day_type == 'day' && (detail.period_config.daily_start > 0 || detail.period_config.daily_end > 0)){
						let {daily_start, daily_end} = detail.period_config;
						let Today = new Date(new Date(new Date().getTime()).setHours(0,0,0,0)).getTime();
						if(new Date().getTime() < Today+daily_start*1000 || new Date().getTime() > Today+daily_end*1000){
							this.props.myEnrollStore.setCurrentEnroll({info_id: detail.info_id});
							this.props.history.push('/cert?day_type=day');
							return;
						}			 						 						
					}
					await this.getEnrollStatus(detail)
					await this.userNickname.checkUserName(); //判断是否有昵称					
					this.props.enrollStore.getItemData().then(()=>{
						this.gotoEnroll(detail)
					})							
				}}>
					<span>{detail.btn_config && detail.btn_config.text ? detail.btn_config.text : this.state.btnTypeText[detail.btn_type]}</span>
					{
						!this.state.isHideBtn && detail.btn_config && (detail.btn_config.btn_cd == 1 || detail.btn_config.btn_cd == 2)? 
						<span className="cen-countdown">剩余{timeInfo.hour}小时{timeInfo.minute}分钟{timeInfo.second}秒</span> : ''
					}					
				</Button>
			} else if(detail.status == 2 && detail.info_id && detail.on_behalf == 0) {
				return(
					<Button type="primary" style={btnColor} onClick={() => {
						this.props.enrollStore.getItemData().then(()=>{
							this.props.myEnrollStore.setCurrentEnroll({info_id: detail.info_id});
							if (detail.verified == 4) {
								this.props.history.push({
									pathname: '/enrollLock',
									search: 'info_id=' + detail.info_id + '&eid=' + (Config.EID || detail.eid || '') + '&temp=' + (detail.temp || 0) + '&verify=' + (detail.verify || 0) + '&auth=' + (detail.auth || 0)
								});
							} else {
								this.props.history.push('/enrollForm');
							}
						})	                
	                }}>查看/取消</Button>)
			} else if(detail.status == 2 && (detail.info_id || detail.on_behalf)) {
				return(
					<Button type="primary" style={btnColor} onClick={()=>{
						this.props.enrollStore.getItemData().then(()=>{
							this.props.history.push('/enrollList')
						})						
					}}>查看/取消</Button>)
			} else if(detail.temp != 8 && detail.status == 1 && (detail.info_id || (detail.period == 1 && detail.period_info)) && (isEditor || (detail.on_behalf_limit == 0 && detail.period_config && !detail.period_config.count))) {
				return(
					<Button type="primary" className='enroll-btn' style={btnColor} onClick={() => {						 
						this.props.enrollStore.getItemData().then(()=>{					 
							this.props.myEnrollStore.setCurrentEnroll({info_id: detail.info_id});
							if (detail.verified == 4) {
								this.props.history.push({
									pathname: '/enrollLock',
									search: 'info_id=' + detail.info_id + '&eid=' + (Config.EID || detail.eid || '') + '&temp=' + (detail.temp || 0) + '&verify=' + (detail.verify || 0) + '&auth=' + (detail.auth || 0)
								});
							} else {
								this.props.history.push('/enrollForm');
							}
						})	                    
	                }}>编辑/取消</Button>)
			}
			else if(detail.status == 1 && ((detail.info_id || (detail.period == 1 && detail.period_info)) || (detail.period_config &&  detail.period_config.count > 1) ||  (detail.period_config && !detail.period_config.count && detail.on_behalf_limit != 0))) {
				return(
					<Button type="primary" className='detail-submit-btn enroll-btn' style={btnColor} onClick={async () =>{		
						await this.userNickname.checkUserName(); //判断是否有昵称				
						this.props.enrollStore.getItemData().then(()=>{
							this.props.history.push('/enrollList')
						})							
					}}>
						<span>新增/取消</span>
						{
							!this.state.isHideBtn && detail.btn_config && detail.btn_config.btn_cd == 1 ? 
							<span className="cen-countdown">剩余{timeInfo.hour}小时{timeInfo.minute}分钟{timeInfo.second >= 10 ? timeInfo.second : '0' + timeInfo.second}秒</span> : ''
						}
					</Button>)
			} 
		}else{
			return <Button type="primary" style={btnColor} onClick={() => {
				this.handleUnauthEnroll(detail)
			}}>{detail.btn_config && detail.btn_config.text ? detail.btn_config.text : this.state.btnTypeText[detail.btn_type]}</Button>		
		}

		return null;
	}

	// 判断发起人是否设置了所有人不可提交
	getEnrollStatus(detail){
		return new Promise((resolve,reject)=>{
			if(detail.sub_user_type == 'end_all'){
				Modal.alert('温馨提示','发起人设置了所有人不可提交，暂时不可提交', [
					{ text: '取消', style: 'default'},
					{ text: '去留言', onPress: () => {	
						WxApi.setMessageUserStyle(detail.user_style);
						this.props.history.push('/message') 
					} },
				])
				reject()
			}
			resolve()
		})		
	}
	
	getsShareImg(type,detail) {
		this.props.enrollStore.getShare(type).then((d) => {
			if(d && d.url) {
				if(type == 1){
					this.setState({
					    shareImgUrl: d.url,
					})
					this.props.myEnrollStore.setShareImg(d.url)
				}
				if(detail){
					this.setState({sharePanel:'none'})
					React.$wx.previewImage({
						current: d.url, // 当前显示图片的http链接
						urls: [d.url] // 需要预览的图片http链接列表
					});
				}
			}
		});
	}

	shareQrcode(detail) {
		var url = detail.follow.qrcode;
		React.$wx.previewImage({
			current: url, // 当前显示图片的http链接
			urls: [url] // 需要预览的图片http链接列表
		});
	}

	showFollow() {
		var url = 'https://cdn-xcxcustom.weiyoubot.cn/20190321/0c898d0e90173f659ef8e135d2a8c4c1.jpeg';
		React.$wx.previewImage({
			current: url, // 当前显示图片的http链接
			urls: [url] // 需要预览的图片http链接列表
		});
	}

	qrCodeBox(detail) {
		var follow = detail.follow;
		if(follow.title && (follow.visi || (follow.visi == 0 && detail.info_id))) {
			return(
				<Flex className="qrcode-box" onClick={() => {
                        this.shareQrcode(detail)
                    }}>
                    <img src={detail.follow.header} className="qrcode-icon" />
                    <div className="qrcode-body">
                        <div className="qrcode-title">{follow.title}</div>
                        <div className="qrcode-desc">{follow.desc}</div>
                    </div>
                    <Button>{follow.type == 1 ? "添加" : (follow.type == 2 ? "关注" : "进群")}</Button>
                </Flex>
			)
		}
	}
 
	reserveBtn(detail, item, index) {
		if (item.pause) {
			return (<div className="btn-reserve btn-disabled">已暂停</div>)
		}
		else if (detail.status == 2) {
			return (<div className="btn-reserve btn-disabled">已结束</div>)
		}
		else if (detail.status == 0) {
			return (<div className="btn-reserve btn-disabled">未开始</div>)
		}else if(!item.timespan.length){
			return (<div className="btn-reserve">已满</div>)
		}
		else {
			return (<div className="btn-reserve">预约</div>)
		}
	}

	handleTransfor(detail){
		if(detail.is_owner){
			Modal.alert('温馨提示','不能转载自己的活动',[{ text: '我知道了' }]);
			return;
		}
		const params = {
			eid: detail.eid,
			type: 'sub'
		}
		this.props.myEnrollStore.reshippedEnroll(params).then(res=>{
			if(res.sta == 0){
				this.showSharePanel('none');
				Modal.alert('温馨提示', '转载成功，请到你的个人主页查看', [					
					{ text: '取消', onPress: () => console.log('ok')},
					{ text: '前往主页查看', onPress: () => {
						React.$wx.jumpNewPath.call(this,'/h/'+detail.unionid);
					}},
				]);			 				
			}else{
				Toast.fail(res.msg);
			}
		})
	}

	showSharePanel(type){
		this.setState({
	        sharePanel: type,
	    })
	}
	//分享选择面板
	goDetailSharePage(tab, detail) {
		// 传递入口权限上下文，避免分享页详情接口未返回权限字段时误展示内容。
		let sharePath = `/detail-share?eid=${detail.eid}&tab=${tab}&share=${detail.share || 0}&info_id=${detail.info_id || 0}&is_owner=${detail.is_owner || 0}&is_admin=${detail.is_admin || 0}&admin1=${detail.admin1 || 0}&admin3=${detail.admin3 || 0}&canOpt=${detail.canOpt || detail.can_opt || 0}`;
		if(detail.unionid){
			sharePath += `&referer=${detail.unionid}`;
		}else if(Config.referer){
			sharePath += `&referer=${Config.referer}`;
		}
		this.setState({
			sharePanel: 'none',
		}, () => {
			this.props.history.push(sharePath);
		});
	}
	renderSharePanel(is_show,detail) {
			// 仅 share=1 为参与人可转发，详情 API 返回有效 info_id 后才显示直接分享入口。
			const hasJoinedActivity = detail.info_id !== undefined && detail.info_id !== null && detail.info_id !== '' && detail.info_id !== 0 && detail.info_id !== '0';
			const canShareToFriend = Number(detail.share) !== 1 || hasJoinedActivity;
			return(
				<Flex className="Detail-share-choice-panel" style={{display:this.state.sharePanel}}>
	    			<div className="share-choice-mask" onClick={() => { this.showSharePanel('none')}}></div>
	    			<div className="share-choice-panel">
	    				<div className="share-btn-panel">
					{canShareToFriend ? <div className="share-icon" onClick={() => {
								let _url = `https://p.baominggongju.com/detail?eid=${detail.eid}`;
								if(detail.unionid){
									_url += `&referer=${detail.unionid}`;		
								}else if(Config.referer){
									_url += `&referer=${Config.referer}`;							
								}
								WxApi.copeText(_url);
								this.showFriend('block');
							}}>
	    						<i></i>
	    						<div>分享给好友</div>
					</div> : null}
	    					<div className="share-icon poster-img" onClick={() => { this.goDetailSharePage('poster', detail) }}>
	    						<i></i>
	    						<div>海报分享图</div>
	    					</div>
							<div className="share-icon wx-img" onClick={() => { this.goDetailSharePage('mini', detail) }}>
	    						<i></i>
	    						<div>小程序码</div>
	    					</div>
	    					<div className="share-icon qrcode-img" onClick={() => { this.goDetailSharePage('qrcode', detail) }}>
	    						<i></i>
	    						<div>二维码</div>
	    					</div>
							<div className="share-icon mobile-img" onClick={() => {
								this.goDetailSharePage('link', detail);
								return;
								let _url = `https://p.baominggongju.com/detail?eid=${detail.eid}`;
								if(detail.unionid){
									_url += `&referer=${detail.unionid}`;		
								}else if(Config.referer){
									_url += `&referer=${Config.referer}`;							
								}
								WxApi.copeText(_url);
								Toast.success('链接复制成功');
								this.setState({sharePanel: 'none'});
							}}>
	    						<i></i>
	    						<div>网页链接</div>
	    					</div>	
							{/*
							<div className='share-icon command-img' onClick={()=>{	
								this.props.history.push('/command');								 							
							}}>
								<i></i>
								<div>活动口令</div>
							</div>	
							*/}
							{/* {
								detail.is_owner != 1 ? 
								<div className="share-icon transfor-img" onClick={() => {this.handleTransfor(detail)}}>
									<i></i>
									<div>转载到主页</div>
								</div> : ''
							}												  */}
	    				</div>
	    				<div className="cancel-btn" onClick={() => { this.showSharePanel('none')}}>取消</div>
	    			</div>
	    		
	    		</Flex>
			)
	}
	
	
	// 未登录报名时，第三方内置浏览器无法拉起小程序，改为展示活动小程序码。
	handleUnauthEnroll(detail){
		if(WxApi.isMobile() && !WxApi.isWeixn()){
			if(WxApi.isOtherEnvironments() || WxApi.isUnionPay()){
				this.showEnrollQrCode();
			}else{
				this.getTicket(detail);
			}
			return;
		}
		this.showMinProgram();
	}

	showMinProgram(){
		React.$wx.webLogin()
	}

	// 第三方内置浏览器展示固定的打开方式引导图。
	showEnrollQrCode(){
		this.setState({showEnrollQrCode: 'block'});
	}

	// 图片外的遮罩区域关闭引导弹框。
	renderEnrollQrCode(){
		return(
			<Flex className="Detail-minProgram-panel" style={{display:this.state.showEnrollQrCode || 'none'}}>
				<div className="share-choice-mask" onClick={() => { this.setState({showEnrollQrCode: 'none'}) }}></div>
				<div className="minProgram-panel" style={{width:'230px', right:'16px', top:'10px', left:'auto', marginLeft:0, transform:'none'}}>
					<img
						src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2026-08-05/1c766d1117a17e51644a8aac7133e540.png"
						alt=""
						style={{display:'block', width:'230px', height:'173px'}}
					/>
				</div>
			</Flex>
		)
	}


	showDetailQrCode(type){
		if(type == 'block'){
			React.$wx.openWeChat(this.wxJumpPath).then(()=>{
				let self = this;
				this.props.enrollStore.getShare(1).then((d) => {
					if(d && d.url) {
						self.setState({
							showDetailQrCode: type,
							detailQrCode: d.url,
						})
					}
				});
			})	
		}else{
			this.setState({
				showDetailQrCode: 'none'
			})
		}
		 		
	}
	//查看小程序二维码
	renderDetailQrCode(){
		return(
			<Flex className="Detail-minProgram-panel" style={{display:this.state.showDetailQrCode}}>
				<div className="share-choice-mask" onClick={() => { this.showDetailQrCode('none')}}></div>
				<div className="minProgram-panel">
				<div className="new-share-minImg">
					<i className="close-btn" onClick={() => { this.showDetailQrCode('none')}}></i>
					<div className="panel-title">请去「报名工具」小程序查看</div>
					<div className="QRCode-img">
						<img src={this.state.detailQrCode} />
					</div>
					<div className="min-tips">长按识别二维码，立即体验</div>
					</div>
				</div>
			</Flex>
		)
	}

	showHomePageQrCode(type, detail){
		let self = this;
		this.props.enrollStore.getHomePageShare(detail.owner_unionid).then((d) => {
			if(d && d.url) {
				self.setState({
					showHomePageQrCode: type,
					detailQrCode: d.url,
				})
			}
		});

	}
	//查看小程序二维码
	renderHomePageQrCode(detail){
		return(
			<Flex className="Detail-minProgram-panel" style={{display:this.state.showHomePageQrCode}}>
				<div className="share-choice-mask" onClick={() => { this.showHomePageQrCode('none', detail)}}></div>
				<div className="minProgram-panel">
					<i className="close-btn" onClick={() => { this.showHomePageQrCode('none', detail)}}></i>
					<div className="panel-title">长按识别二维码，查看Ta的主页</div>
					<div className="QRCode-img">
						<img src={this.state.detailQrCode} />
					</div>
				</div>
			</Flex>
		)
	}
	// 查看活动口令
	renderEnrollToken(){
		return(
			<Modal
			visible={this.state.showEnrollToken}
			closable={true}
			transparent			
			onClose={()=>{this.setState({showEnrollToken:false})}}
			title="分享当前活动"				
		 	>
			<div className='modal-address-panel'>
				<p className='token-title'>参与人打开小程序可以直接进入活动页面</p>
				<p className='token-content'>{this.state.enroll_token} 打开报名工具小程序首页搜索</p>
				<Button type="primary" className='copy-btn' onClick={()=>{
					WxApi.copeText(this.state.enroll_token + ' 打开报名工具小程序首页搜索');
					Toast.success('复制成功');
					this.setState({showEnrollToken:false});
				}}>复制口令</Button>
			</div>
		  </Modal>			 
		)
	}

	// 线上活动地址
	renderLink(detail){		 
		return (
			<Modal
			visible={this.state.showLink}
			closable={true}
			transparent			
			onClose={()=>{this.setState({showLink:false})}}
			title="线上活动地址"				
		 	>
			<div className='modal-address-panel'>
				<p className='address-content'>{detail.address}</p>
				<Button type="primary" className='copy-btn' onClick={()=>{
					WxApi.copeText(detail.address);
					Toast.success('复制成功');
					this.setState({showLink:false});
				}}>一键复制</Button>
			</div>
		  </Modal>
		)
	}

	// 复制微信
	renderWxLink(detail){		 
		return (
			<Modal
			visible={this.state.showWxlink}
			closable={true}
			transparent			
			onClose={()=>{this.setState({showWxlink:false})}}
			title="微信号"				
		 	>
			<div className='modal-address-panel'>
				<p className='address-content'>{detail.wx_no}</p>
				<Button type="primary" className='copy-btn' onClick={()=>{
					WxApi.copeText(detail.wx_no);
					Toast.success('复制成功');
					this.setState({showWxlink:false});
				}}>一键复制</Button>
			</div>
		  </Modal>
		)
	}
	
	// 有争议的活动
	renderCensorModal(){
		return (			 
			<Modal
			popup
			visible={this.state.censorModal}
			onClose={()=>{this.setState({censorModal: false })}}
			animationType="slide-up"	
			className='modal-censor-panel'						
			>
				<div className='main-container'>
					<div>
						<img className="warn-img" src="https://gw.alipayobjects.com/zos/rmsportal/GIyMDJnuqmcqPLpHCSkj.svg" />
						<h4 className='warn-title'>活动存在有争议的内容</h4>
						<span>请耐心等待协商解决</span>
					</div>
					<div className="footer-panel">
						<Button className='cen-button continue-btn' onClick={()=>{
							this.setState({ censorModal: false });
						}}>继续访问</Button>
						<Button className='cen-button cancel-btn' type="primary" onClick={()=>{
							this.setState({ censorModal: false });
							this.props.history.push('/manage/myEnroll');
						}}>取消</Button>
					</div>
				</div>					
			</Modal>			 
		)
	}

	showFriend(type){
		this.setState({
	        shareFriend: type,
	        sharePanel: 'none',
	    })
	}
	renderShareTips(){
		return(
			<Flex className="Detail-share-tips-panel" style={{display:this.state.shareFriend}}>
				<div className="share-choice-mask" onClick={() => { this.showFriend('none')}}></div>
				<div className="tips-content" onClick={() => { this.showFriend('none')}}>
					<img className="arrow-share" src={img_mask_arrow} />
					<div className="share-text">
						<span>邀请链接已复制到剪切板</span><br/>
						<span>也可以点击右上角“...”完成分享</span><br/>					 
					</div>
				</div>
			</Flex>
		)
	}

	// 预约项目
	reservePro(detail) {
		if (detail.temp == 8 && this.state.showReverse) {
            return(
             <div className="reverse-info-panel">
				<div className="mask" onClick={() => {
					this.setState({
						showReverse: false,
						})
					}}>
				</div>
				<div className="reserve-box">
				  <div className="reserve-title">请选择</div>
					<div className="reserve-main">
					{
						<div className="reserve-left-menu">
							{
								this.state.tagList.map((item,index)=>{
									return (
										<div className="menu-item" style={{'backgroundColor':index == this.state.currIndex?'#fff':''}} onClick={()=>{
											const currTags = this.state.tagList[index]
											if(currTags == '全部'){
												this.state.reverseList = detail.items
											}else{
												this.state.reverseList = detail.items.filter(item=>{
													return item.tag == currTags
												})
											}

											this.setState({
												currIndex:index,
												reverseList:this.state.reverseList
											})
										}}>{item}</div>
									)
								})
							}
						</div>
					}
					{
						<div className="reserve-data">
						{
							Array.isArray(this.state.reverseList) ? this.state.reverseList.map((item, index) => {
								let reverse_pic = WxApi.getAutoImage(item.pics[0], 160, 'single')
								return(
									<div className="reserve-item" key={index} onClick={()=>{
										if(!item.pause && detail.status != 2 && detail.status != 0){
											if(!item.timespan.length){
												this.props.history.push('/cert?isOver=1');
											}else{											 
												if(item && item.key){ //如果有分类，则索引需要进行匹配
													let i = detail.items.findIndex(data=>data.key == item.key);
													if(i > -1){ index = i };
												}
												window.reserve_index = index;
												this.props.myEnrollStore.setItemIndex(index);
												this.props.myEnrollStore.setCurrentEnroll(0);
												this.props.history.push('/enrollForm');											 
											}
										}
									}}>
										<img className="reserve-icon" src={reverse_pic} onClick={(e) => {
											e.stopPropagation();
											React.$wx.previewImage({
												current: item.pics[0], // 当前显示图片的http链接
												urls: item.pics
											});
										}
										} />
										<div className="reserve-bd">
										<div className="reserve-name">{item.name}</div>
										<div className="reserve-desc">{item.desc}</div>
										{ this.renderFee(item) }
										</div>
										{
											this.reserveBtn(detail, item, index)
										}
									</div>
								)
							}) : null
						}
						</div>
					}
					</div>
				</div>
			 </div>
			)
		}
	}
	
	//渲染座位
	renderSeat(detail) {
		if(detail.temp == 10 && detail.items && detail.items.length > 0 && this.state.showSeat){
			const {setItemKey, setSeatFee, setItemIndex} = this.props.myEnrollStore;
			return(
				<div className="seat-info-panel">
					<div className="mask" onClick={() => {
							this.setState({
								showSeat: false,
							})
						}}></div>
					<div className="seat-panel">
						<div className="seat-title">
							<div className="title-text">请选择</div>
							<img onClick={() => {
							this.setState({
								showSeat: false,
							})
						}} src={close_btn}></img>
						</div>
						<div className="seat-content-box">
							{
								detail.items.map((item,index) =>{
									let seat_pics = WxApi.getAutoImage(item.pics[0], 160, 'single');
									return(
										<div className="seat-item" onClick={() => {
											if(item.booked.length == item.seatNum){
												this.props.history.push('/cert?isOver=1');
											}else{
												window.reserve_index = index;
												setItemKey(item.key);
												setItemIndex(index);
												if(item.fee > 0){
													setSeatFee(item.fee);
												}
												this.props.history.push('/seat');
											}
										}}>
											<img className="item-banner" src={seat_pics} onClick={(e)=>{
												e.stopPropagation();
												React.$wx.previewImage({
													current: item.pics[0], // 当前显示图片的http链接
													urls: item.pics
												})
											}}/>
											<div className="item-content">
												<div className="left_panel">
													<div className="item-name">{item.name}</div>
													<div className="seat-num">
													    <span>可选：{item.booked.length}/{item.seatNum}</span>
														{ this.renderFee(item) }
													</div>
												</div>
												{
													item.booked.length == item.seatNum && !item.pause ? 
													<Button size='small' className='over-btn' type="primary">已满</Button> : ''
												}
												{
													item.pause ? <Button size='small' className='pause-btn' type="primary" disabled>已暂停</Button> : null
												}
												<img className="right-arrow" src={right_arrow} />
											</div>
										</div>
									)
									
								})
							}
						</div>
					</div>
				
				</div>
			)
		}
		
	}

	renderFee(item){
	    if(item && item.def_fee){
			if(item.vip_pay_setting && item.vip_pay_setting.length){
		
				return (
					<div className="fee-text">
						{ item.def_fee.fee ? <span className="fee-num">￥{item.def_fee.fee/100}</span> : null }						
						<div className='vip-info'>
							{
								item.vip_pay_setting.map((data, index)=>{
									return (
										<div className="vip-price" key={index} onClick={()=>{
											React.$wx.jumpNewPath.call(this,'/apply-vip?cid='+data.vip_card_id)
										}}>                                    
											{ data.card_type == 1 ? 
											<span>￥{data.fee/100}<span className='gray-text'>{data.card_name}</span></span>
											: <span>{data.card_cert_num}次<span className='gray-text'>{data.card_name}</span></span> 
											}                                  
										</div>
									)
								})
							}
						</div>
					</div>
				)
			}else if(item.def_fee.fee && item.vip_card_id){
            	return <div className="fee-text">
						<span className="fee-num">￥{item.def_fee.fee/100}</span> 
						<span className="vip-fee-text">￥{item.def_fee.vip_fee/100}<span className='gray-text'>{item.vip_card_title}</span></span>
					</div>
            }else if(item.def_fee.fee){
            	return <span className="fee-text">￥{item.def_fee.fee/100}</span>
            }else if(item.vip_card_id){
            	return <div className="fee-text">
					<span className="vip-fee-text">￥{item.def_fee.vip_fee/100}<span className='gray-text'>{item.vip_card_title}</span></span>
					
				</div>
            }else if(item.fee){
                return 
            }
        }else if(item && item.fee){//旧数据取值
            return <div className='fee-text'>￥{item.fee / 100}</div>
        } 
	}

	render() {
		let {detail} = this.props.enrollStore;		
		let miniBtn = {
			flex:'1',
			height:'40px',
			backgroundColor:"#fff",
			border:'1px solid #ccc',
			borderRadius:'5px',
			cursor:'point'
		}
		const connection = navigator.connection || navigator.networkInformation;
		const networkType = connection && connection.effectiveType ? connection.effectiveType : '未知';
		const browserName = WxApi.getBrowserName();
		const userName = this.props.enrollStore.userInfo && this.props.enrollStore.userInfo.uname ? this.props.enrollStore.userInfo.uname : '';
		const currentLink = window.location.href || '';
		if(!detail.title) {
			return(
				<div>
					{this.state.hasActive?
						(<div className="Detail-init-render-result">
							<div className="title">数据加载中</div>
							<div className="message">请稍后...</div>
						</div>
					):
					(
						<div className="Detail-init-render-result">
							<img className="cen-image" src="https://cdn-xcxcustom.weiyoubot.cn/20210526/f6cf229bd87b77f3c7f0e5d6b855ea4d.png"></img>
							<div className="cen-title">活动不存在</div>
							<span className="cen-warn">被删除或被清理的活动可前往回收站查看</span>
							<div className='warn-content'>
								<div style={{display:'flex'}}>
									<div className='content-items' style={{width:'50%'}}>
									<span className='cen-label'>网络：</span>
									<span>{networkType}</span>
								</div>
									<div className='content-items' style={{width:'50%'}}>
										<span className='cen-label'>浏览器：</span>
										<span>{browserName}</span>
									</div>
								</div>
								<div className='content-items'>
									<span className='cen-label'>昵称：</span>
									<span>{userName}</span>
								</div>
								<div className='content-items'>
									<span className='cen-label'>链接：</span>
									<span className='cen-content'>{currentLink}</span>
								</div>
							</div>
							<div className='back-home-btn'>								 
								<button type="primary" style={miniBtn} onClick={()=>{
									this.props.history.push('/recycleBin')
								}}>查看回收站</button>										 		
								<button className='my-record' onClick={()=>{
									window._hmt.push(['_trackPageview',  '/manage/myEnroll'])
									this.props.history.push('/manage/myEnroll')
								}}>我的记录</button>							
							</div>							
							<div className="lottery-box" onClick={()=>{
								window.open('https://xcx.qunsou.co/recommend.html?appId=wxfaa08012777a431e');
							}}>
								<img className="lottery-banner" src={this.state.lotteryBanner} />
							</div>												
						</div>
					)
				}	
                </div>
			)
		}
		
		return(
			<div className="btn_bottom" style={{paddingTop: detail && detail.user_style != 2 ? '50px' : '0'}}>
                {
                    detail.user_style != 2 ? this.renderHeader(detail) : null
                }
				{
					this.renderWxCode(detail)
				}
				<article className="detail-article">
                {						 
					!this.state.isVertical ? this.renderBanner(detail) : null
                }
                {
                    !this.state.isVertical ? this.renderContent1(detail) : null
                }
				{
					this.state.isVertical ?
					<div className='vertical-screen'>
						{
							this.renderBanner(detail)
						}
						{
							this.renderContent1(detail)
						}
					</div> : null
				}
				{
					detail.user_style !== 2 && (
						(!detail.co_create || (detail.co_create == 1 && !detail.team_user.length))
						? this.renderOwner(detail)
						: this.renderEnrollGroup(detail)
					)
				}
                {
                    !!detail.group_qr ? <List className="qun-view">
                        <Item
                            arrow="horizontal"
                            thumb={
                                <Badge text={1}>
                                    <img style={{width: 30, height: 30}} src={img_qun}/>
                                </Badge>
                            }
                            multipleLine
                            onClick={() => {
                                React.$wx.previewImage({
                                    current: detail.group_qr, // 当前显示图片的http链接
                                    urls: [detail.group_qr] // 需要预览的图片http链接列表
                                });
                            }}
                            extra={<Button inline={"true"} size="small">加入</Button>}
                        >
                            官方交流群 <Brief>邀请你进群参加交流讨论</Brief>
                        </Item>
                    </List> : null
                }

                {
                    this.renderDescribe(detail, detail.auth == 0)
                }
				{
					detail.auth == 0 ? this.renderAdvert() : null
				}
			</article>
				{
					detail.censor_status == 3 ? this.renderCensorModal(detail) : null
				}
				{
					this.renderMsgDialog(detail)
				}								 
                {
                	this.renderSharePanel('none',detail)
                }
                {
                	this.renderDetailQrCode()
                }
                {
                	this.renderEnrollQrCode()
                }
                {
                	this.renderHomePageQrCode(detail)
                }
				{
					this.renderEnrollToken()
				}
				{
					this.renderLink(detail) //微信短链弹窗
				}
				{
					this.renderWxLink(detail)
				}
                {
                	this.renderShareTips()
                }
                {
                	this.renderTokenPanel(detail)
                }
				{
					this.renderSubmitRead(detail)
				}
                {
                    ((detail.user_visible == 1 || detail.user_visible == 2) || detail.is_owner || detail.admin == 1) ?
                        <UserList eid={this.props.match.params.eid} themColor={this.state.themColor} is_await={detail.is_await} wxJumpPath={this.wxJumpPath} history={this.props.history} openMsg={()=>{
							this.child.setDialog('open')
						}}/> : null
                }
                {
					this.renderNotice(detail)
				}
				{
					detail.sub_user_setting && detail.sub_user_setting.indexOf('group_enter') != -1 && (detail.admin3 == 1 || detail.is_owner) ? this.renderWxGroup(detail) : null
				}
                {/*</PullToRefresh>*/}
				{
					!this.state.isWeixin &&!Config.TOKEN ? <div className="fix_bottom_weixin" onClick={() => {
						// 覆盖层与报名按钮保持相同的未登录跳转逻辑。
						this.handleUnauthEnroll(detail);
					}}></div> : null
				}
                <div className="fix_bottom" >
                    <div className="share-panel" style={{flex: 3}}>
						{
							detail.is_owner || (detail.admins_node && detail.admins_node.length > 0) || detail.is_move ? null :
							<a className="create btn" href={withAppBasename('/h/' + detail.owner_unionid)} onClick={() => { 
								window._hmt.push(['_trackEvent', 'button_to_homepage','', '活动详情底部菜单点击主页', '']); //百度统计
							}}>
								<i className="create-icon icon-style"></i>
								<div>主页</div>
							</a>
						}													
	                    	<button className="share btn" onClick={() => {
								// share=3 仅允许发起人或管理员分享，其他用户直接提示并拦截。
								if(Number(detail.share) === 3 && Number(detail.is_owner) !== 1 && Number(detail.is_admin) !== 1){
									Modal.alert('温馨提示', '发起人设置了不允许他人分享', [{ text: '我知道了' }]);
									return;
								}
								this.showSharePanel('block')
							}}>
	                    		<i className="share-icon icon-style"></i>
	                    		<div>分享</div>
	                    	</button>
						<button className="message-box-panel btn">
							<div className="share btn message-btn" onClick={(e) => {
								e.stopPropagation()
								if(!Config.TOKEN){
									React.$wx.webLogin()
								}else if(!WxApi.isWeixn() && WxApi.isMobile() && !wxapi.isUnionPay()){
									this.getTicket(detail)
								}else{							
									WxApi.setMessageUserStyle(detail.user_style);
									this.props.history.push('/message')							
								}	
							}}>
								<div style={{position:'relative', width: '20px', margin: '0 auto'}}>
									<i className="message-icon icon-style"></i>
									{
										(detail.is_owner || detail.admin1 == 1) && detail.msg_count > 0 ? <span className='share-num'>{detail.msg_count > 999 ? '99+' : detail.msg_count}</span> : null
									}							
								</div>									
								<div>{detail.is_owner || detail.admin1 == 1 ? '消息' : '留言'}</div>
							</div>
						</button>
						{
							detail.is_owner || (detail.admins_node &&  detail.admins_node.length > 0) ?
							<button className="create btn" onClick={()=>{
								this.setState({showManage: true})
							}}>
								<img className='manage-icon' src='https://cdn-xcx-qunsou.weiyoubot.cn/material/20230131/c996d91ae7afccb3e26b7b2f487728a1.png' />
								<div>管理</div>
							</button> : null
						}
						{
							!(detail.is_owner || (detail.admins_node && detail.admins_node.length > 0)) && detail.is_move ? 
							<button className="transfer-btn share btn" onClick={()=>{
								if(detail.info_id){
									this.props.history.push('/transfor?type=1');									
								}else{
									this.props.history.push('/transfor');
								}								
							}}>								 
								<div style={{position:'relative', width: '20px', margin: '0 auto'}}>
									<img className='manage-icon' src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-01-11/9fd1b90f631f9bb3a98495c4f7298402.png"></img>	
									{/* <span className='share-num'>{detail.move_total > 99 ? '99+' : detail.move_total}</span> */}
								</div>							 
								<div>求/转</div>
							</button> : null
						}						
                    </div>
					<div className='main-btn' style={{flex: 4}}>
						{
							detail.info_id ? <div className='voucher-box' style={{borderColor: detail.btn_config.color}} onClick={()=>{
								this.setState({showVoucher: true});
							}}>
								<img className='voucher-img' src='https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-10-17/f2565da0f2d843e9ab2471a7f52f5807.svg'></img>
							</div> : null
						}						
						{ this.renderButton(detail) }
					</div>
                  
					{
						this.renderSeat(detail)
					}
					{
						this.reservePro(detail)
					}
					{
						detail.is_owner || (detail.admins_node && detail.admins_node.length > 0) ? <ManageDialog showManage={this.state.showManage} wxJumpPath={this.wxJumpPath} openAdmin={()=>{
							this.setState({showManage: false});
							this.props.history.push('/admin?eid=' + detail.eid + '&auth=' + (detail.auth || 0) + '&status=' + (detail.status || 0) + '&unionid=' + (detail.owner_unionid || detail.unionid || ''));
						}} openAdminRole={()=>{
							// 管理员查看自己的权限（对齐小程序 subpackage/admin/adminRole，unionid 为当前用户）
							this.setState({showManage: false});
							this.props.history.push('/adminRole?eid=' + detail.eid + '&unionid=' + (detail.unionid || ''));
						}} open={()=>{
							this.setState({showManage: false});
							this.showDetailQrCode('block');
						}} exportData={()=>{
							// 导出数据跳转H5导出页面，需登录态
							this.setState({showManage: false});
							if(!Config.TOKEN){
								React.$wx.webLogin();
								return;
							}
							this.props.history.push('/exportData');
						}} deleteEnroll={()=>{
							// 删除活动：关闭管理面板，打开删除确认弹窗
							this.setState({showManage: false, deleteDialogShow: true});
						}} sendNotice={()=>{
							// 发送通知：关闭管理面板，跳转通知列表页（对齐小程序 /create/notice/notice）
							this.setState({showManage: false});
							if(!Config.TOKEN){
								React.$wx.webLogin();
								return;
							}
							this.props.history.push('/notice');
						}} toCheckin={()=>{
							// 核销签到：新开 H5 独立页面（对齐小程序 detail.js toCheckin 的跳转参数）
							this.setState({showManage: false});
							this.props.history.push('/checkin?eid=' + detail.eid
								+ '&is_owner=' + (detail.is_owner || (detail.admins_node && detail.admins_node.length > 0) ? 1 : 0)
								+ '&auth=' + (detail.auth || 0)
								+ '&rank=' + (detail.rank_switch || 0)
								+ '&temp=' + (detail.temp || 0));
						}} refresh={()=>{
							// 截止/开启活动成功后刷新详情，状态同步到按钮文案
							this.getDetail();
						}} close={()=>{
							this.setState({showManage: false});
						}}></ManageDialog> : null
					}					 
					<VocherModal showVoucher={this.state.showVoucher} open={()=>{						
						this.setState({showVoucher: false});
						this.props.history.push('/voucher');						 
					}} close={()=>{
						this.setState({showVoucher: false});
					}}></VocherModal>				 
					<DeleteEnrollDialog show={this.state.deleteDialogShow} status={detail && detail.status} onCancel={()=>{
						this.setState({deleteDialogShow: false});
					}} onExportData={()=>{
						// 删除前先导出数据备份
						if(!Config.TOKEN){
							React.$wx.webLogin();
							return;
						}
						this.props.history.push('/exportData');
					}}></DeleteEnrollDialog>
					<SetUserInfo ref="userDom" needLogin={detail.need_login} onRef={(ref)=>{ this.userNickname = ref}}></SetUserInfo>
                </div>
            </div>
		);
	}
}

export default App;
